//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.1.0.0 (NJsonSchema v11.0.2.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming

import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
import { Injectable, InjectionToken, inject } from '@angular/core';
import { ToastService, ToastType } from '@instaclause-webapp/shared-ui';
import { Observable, of as _observableOf, throwError } from 'rxjs';
import { catchError, mergeMap as _observableMergeMap } from 'rxjs/operators';

interface RequestOptions {
  handleError: Boolean;
}
export interface FileParameter {
    data: any;
    fileName: string;
}
export const apiBaseUrl = new InjectionToken<string>('apiBaseUrl');

@Injectable()
export class ClausesClient {
  private http = inject(HttpClient);
  private toastService = inject(ToastService);
  private apiBaseUrl = inject(apiBaseUrl, { optional: true });
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    this.baseUrl = this.apiBaseUrl ?? 'https://expert.dev.instaclause.com/api';
  }

  /**
   * Retrieves a clause by its identifier and language.
   * @param clauseId The unique identifier of the clause to retrieve.
   * @param languageId The identifier of the language for the clause.
   * @return OK
   */
  getById(
    clauseId: number,

    languageId: number,
    options?: RequestOptions
  ): Observable<GetClauseResponse> {
    let url_ = this.baseUrl + '/clauses/{clauseId}?';
    if (clauseId === undefined || clauseId === null)
      throw new Error("The parameter 'clauseId' must be defined.");
    url_ = url_.replace('{clauseId}', encodeURIComponent('' + clauseId));
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetById(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetById(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<GetClauseResponse>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<GetClauseResponse>;
          }
        })
      );
  }

  protected processGetById(response: HttpResponseBase): Observable<GetClauseResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetClauseResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetClauseResponse>(null as any);
  }

  /**
   * Updates a clause.
   * @param clauseId The id of the clause to update.
   * @param body (optional) The request containing the flags indicating which fields to update and the new values.
   * @return OK
   */
  update(
    clauseId: number,

    body?: UpdateClauseRequest | undefined,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/clauses/{clauseId}';
    if (clauseId === undefined || clauseId === null)
      throw new Error("The parameter 'clauseId' must be defined.");
    url_ = url_.replace('{clauseId}', encodeURIComponent('' + clauseId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'patch',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('patch', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processUpdate(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processUpdate(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Deletes a clause.
   * @param clauseId The id of the clause to delete.
   * @return OK
   */
  delete(clauseId: number, options?: RequestOptions): Observable<void> {
    let url_ = this.baseUrl + '/clauses/{clauseId}';
    if (clauseId === undefined || clauseId === null)
      throw new Error("The parameter 'clauseId' must be defined.");
    url_ = url_.replace('{clauseId}', encodeURIComponent('' + clauseId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'delete',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processDelete(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Retrieves a list of clauses, optionally filtered by group id.
   * @param languageId The id of the language of the clauses.
   * @param groupId (optional) The id of the group to filter the clauses by.
   * @return The list of clauses was retrieved successfully.
   */
  get(
    languageId: number,

    groupId?: number | undefined,
    options?: RequestOptions
  ): Observable<GetClausesResponse> {
    let url_ = this.baseUrl + '/clauses?';
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    if (groupId === null) throw new Error("The parameter 'groupId' cannot be null.");
    else if (groupId !== undefined) url_ += 'groupId=' + encodeURIComponent('' + groupId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGet(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<GetClausesResponse>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<GetClausesResponse>;
          }
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<GetClausesResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetClausesResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetClausesResponse>(null as any);
  }

  /**
   * Creates a new clause.
   * @param body (optional) The request containing the name of the clause and the group id.
   * @return OK
   */
  create(
    body?: CreateClauseRequest | undefined,
    options?: RequestOptions
  ): Observable<CreateClauseResponse> {
    let url_ = this.baseUrl + '/clauses';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreate(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<CreateClauseResponse>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<CreateClauseResponse>;
          }
        })
      );
  }

  protected processCreate(response: HttpResponseBase): Observable<CreateClauseResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as CreateClauseResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CreateClauseResponse>(null as any);
  }

  /**
   * Retrieves a grouped structure of contract model groups, contract models and clauses.
   * @param languageId The id of the language of the clauses.
   * @param query (optional) The search query to filter the grouped structure.
   */
  getGroups(
    languageId: number,

    query?: string | undefined,
    options?: RequestOptions
  ): Observable<GetGroupedClausesResponse> {
    let url_ = this.baseUrl + '/clauses/groups?';
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    if (query === null) throw new Error("The parameter 'query' cannot be null.");
    else if (query !== undefined) url_ += 'query=' + encodeURIComponent('' + query) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetGroups(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetGroups(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<GetGroupedClausesResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<GetGroupedClausesResponse>;
          }
        })
      );
  }

  protected processGetGroups(response: HttpResponseBase): Observable<GetGroupedClausesResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetGroupedClausesResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetGroupedClausesResponse>(null as any);
  }

  /**
   * Updates the template of a clause.
   * @param clauseId The id of the clause to update.
   * @param templateTranslationId The id of the template translation to update.
   * @param body (optional) The request containing the updated template details.
   * @return OK
   */
  updateTemplate(
    clauseId: number,

    templateTranslationId: number,

    body?: UpdateTemplateRequest | undefined,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/clauses/{clauseId}/template/{templateTranslationId}';
    if (clauseId === undefined || clauseId === null)
      throw new Error("The parameter 'clauseId' must be defined.");
    url_ = url_.replace('{clauseId}', encodeURIComponent('' + clauseId));
    if (templateTranslationId === undefined || templateTranslationId === null)
      throw new Error("The parameter 'templateTranslationId' must be defined.");
    url_ = url_.replace('{templateTranslationId}', encodeURIComponent('' + templateTranslationId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'put',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateTemplate(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processUpdateTemplate(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processUpdateTemplate(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  private handleError(error: any, options?: RequestOptions) {
    if (options && options.handleError === false) {
      throw error;
    }

    this.toastService.showToast({
      type: ToastType.Error,
      text: error.message,
      duration: 5,
    });

    return _observableOf(null);
  }
}

@Injectable()
export class ContractModelFieldsClient {
  private http = inject(HttpClient);
  private toastService = inject(ToastService);
  private apiBaseUrl = inject(apiBaseUrl, { optional: true });
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    this.baseUrl = this.apiBaseUrl ?? 'https://expert.dev.instaclause.com/api';
  }

  /**
   * Retrieves the fields associated with a specific contract model.
   * @param contractModelId The id of the contract model.
   * @param languageId The id of the language to retrieve the fields in.
   * @return OK
   */
  getFields(
    contractModelId: number,

    languageId: number,
    options?: RequestOptions
  ): Observable<GetContractModelFieldsResponse> {
    let url_ = this.baseUrl + '/contract-models/{contractModelId}/fields?';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetFields(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetFields(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(
                  e,
                  options
                ) as any as Observable<GetContractModelFieldsResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<GetContractModelFieldsResponse>;
          }
        })
      );
  }

  protected processGetFields(
    response: HttpResponseBase
  ): Observable<GetContractModelFieldsResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as GetContractModelFieldsResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetContractModelFieldsResponse>(null as any);
  }

  /**
   * Creates a new field.
   * @param contractModelId The contract model id.
   * @param body (optional) The request with the field data.
   * @return OK
   */
  createFields(
    contractModelId: number,

    body?: CreateFieldRequest | undefined,
    options?: RequestOptions
  ): Observable<CreateFieldResponse> {
    let url_ = this.baseUrl + '/contract-models/{contractModelId}/fields';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateFields(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateFields(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<CreateFieldResponse>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<CreateFieldResponse>;
          }
        })
      );
  }

  protected processCreateFields(response: HttpResponseBase): Observable<CreateFieldResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as CreateFieldResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CreateFieldResponse>(null as any);
  }

  /**
   * Updates a field.
   * @param contractModelId The contract model id.
   * @param fieldId The field id.
   * @param body (optional) The request with the field data to update.
   * @return OK
   */
  updateFields(
    contractModelId: number,

    fieldId: number,

    body?: UpdateFieldRequest | undefined,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/contract-models/{contractModelId}/fields/{fieldId}';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (fieldId === undefined || fieldId === null)
      throw new Error("The parameter 'fieldId' must be defined.");
    url_ = url_.replace('{fieldId}', encodeURIComponent('' + fieldId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'patch',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('patch', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateFields(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processUpdateFields(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processUpdateFields(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Deletes a field.
   * @param contractModelId The id of the contract model.
   * @param fieldId The field id.
   * @return OK
   */
  deleteFields(
    contractModelId: number,

    fieldId: number,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/contract-models/{contractModelId}/fields/{fieldId}';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (fieldId === undefined || fieldId === null)
      throw new Error("The parameter 'fieldId' must be defined.");
    url_ = url_.replace('{fieldId}', encodeURIComponent('' + fieldId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'delete',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteFields(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processDeleteFields(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processDeleteFields(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Creates a new field option.
   * @param contractModelId The contract model id.
   * @param fieldId The field id to add the option.
   * @param body (optional) The request with the field option data.
   * @return OK
   */
  createFieldsOptions(
    contractModelId: number,

    fieldId: number,

    body?: CreateFieldOptionRequest | undefined,
    options?: RequestOptions
  ): Observable<CreateFieldOptionResponse> {
    let url_ = this.baseUrl + '/contract-models/{contractModelId}/fields/{fieldId}/options';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (fieldId === undefined || fieldId === null)
      throw new Error("The parameter 'fieldId' must be defined.");
    url_ = url_.replace('{fieldId}', encodeURIComponent('' + fieldId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateFieldsOptions(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateFieldsOptions(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<CreateFieldOptionResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<CreateFieldOptionResponse>;
          }
        })
      );
  }

  protected processCreateFieldsOptions(
    response: HttpResponseBase
  ): Observable<CreateFieldOptionResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as CreateFieldOptionResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CreateFieldOptionResponse>(null as any);
  }

  /**
   * Updates a field option.
   * @param contractModelId The contract model id.
   * @param optionId The option id to update.
   * @param body (optional) The request with the new option data.
   * @return OK
   */
  updateFieldsOptions(
    contractModelId: number,

    optionId: number,

    body?: UpdateFieldOptionRequest | undefined,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/contract-models/{contractModelId}/fields/options/{optionId}';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (optionId === undefined || optionId === null)
      throw new Error("The parameter 'optionId' must be defined.");
    url_ = url_.replace('{optionId}', encodeURIComponent('' + optionId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'patch',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('patch', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateFieldsOptions(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processUpdateFieldsOptions(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processUpdateFieldsOptions(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Deletes a field option.
   * @param contractModelId The contract model id.
   * @param optionId The option id to delete.
   * @return OK
   */
  deleteFieldsOptions(
    contractModelId: number,

    optionId: number,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/contract-models/{contractModelId}/fields/options/{optionId}';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (optionId === undefined || optionId === null)
      throw new Error("The parameter 'optionId' must be defined.");
    url_ = url_.replace('{optionId}', encodeURIComponent('' + optionId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'delete',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteFieldsOptions(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processDeleteFieldsOptions(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processDeleteFieldsOptions(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Updates the field option template.
   * @param contractModelId The contract model id.
   * @param fieldOptionId The field option ID to update.
   * @param templateTranslationId The template translation ID.
   * @param body (optional) The request containing the update details.
   * @return OK
   */
  updateFieldsOptionsTemplate(
    contractModelId: number,

    fieldOptionId: number,

    templateTranslationId: number,

    body?: UpdateTemplateRequest | undefined,
    options?: RequestOptions
  ): Observable<void> {
    let url_ =
      this.baseUrl +
      '/contract-models/{contractModelId}/fields/options/{fieldOptionId}/template/{templateTranslationId}';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (fieldOptionId === undefined || fieldOptionId === null)
      throw new Error("The parameter 'fieldOptionId' must be defined.");
    url_ = url_.replace('{fieldOptionId}', encodeURIComponent('' + fieldOptionId));
    if (templateTranslationId === undefined || templateTranslationId === null)
      throw new Error("The parameter 'templateTranslationId' must be defined.");
    url_ = url_.replace('{templateTranslationId}', encodeURIComponent('' + templateTranslationId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'put',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateFieldsOptionsTemplate(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processUpdateFieldsOptionsTemplate(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processUpdateFieldsOptionsTemplate(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  private handleError(error: any, options?: RequestOptions) {
    if (options && options.handleError === false) {
      throw error;
    }

    this.toastService.showToast({
      type: ToastType.Error,
      text: error.message,
      duration: 5,
    });

    return _observableOf(null);
  }
}

@Injectable()
export class ContractModelGroupsClient {
  private http = inject(HttpClient);
  private toastService = inject(ToastService);
  private apiBaseUrl = inject(apiBaseUrl, { optional: true });
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    this.baseUrl = this.apiBaseUrl ?? 'https://expert.dev.instaclause.com/api';
  }

  /**
   * Retrieves a list of available contract model groups.
   * @param languageId The id of the language to retrieve the contract model groups in.
   * @return OK
   */
  get(languageId: number, options?: RequestOptions): Observable<GetContractModelGroupsResponse> {
    let url_ = this.baseUrl + '/contract-model-groups?';
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGet(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(
                  e,
                  options
                ) as any as Observable<GetContractModelGroupsResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<GetContractModelGroupsResponse>;
          }
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<GetContractModelGroupsResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as GetContractModelGroupsResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetContractModelGroupsResponse>(null as any);
  }

  /**
   * Creates a new contract model.
   * @param body (optional) The request containing the name of the contract model.
   * @return OK
   */
  create(
    body?: CreateContractModelGroupRequest | undefined,
    options?: RequestOptions
  ): Observable<CreateContractModelGroupResponse> {
    let url_ = this.baseUrl + '/contract-model-groups';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreate(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(
                  e,
                  options
                ) as any as Observable<CreateContractModelGroupResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<CreateContractModelGroupResponse>;
          }
        })
      );
  }

  protected processCreate(
    response: HttpResponseBase
  ): Observable<CreateContractModelGroupResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as CreateContractModelGroupResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CreateContractModelGroupResponse>(null as any);
  }

  /**
   * Retrieves a specific contract model.
   * @param contractModelGroupId The id of the contract model to retrieve.
   * @param languageId The id of the language to retrieve the contract model in.
   * @return OK
   */
  getById(
    contractModelGroupId: number,

    languageId: number,
    options?: RequestOptions
  ): Observable<GetContractModelGroupResponse> {
    let url_ = this.baseUrl + '/contract-model-groups/{contractModelGroupId}?';
    if (contractModelGroupId === undefined || contractModelGroupId === null)
      throw new Error("The parameter 'contractModelGroupId' must be defined.");
    url_ = url_.replace('{contractModelGroupId}', encodeURIComponent('' + contractModelGroupId));
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetById(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetById(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(
                  e,
                  options
                ) as any as Observable<GetContractModelGroupResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<GetContractModelGroupResponse>;
          }
        })
      );
  }

  protected processGetById(response: HttpResponseBase): Observable<GetContractModelGroupResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetContractModelGroupResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetContractModelGroupResponse>(null as any);
  }

  /**
   * Updates a contract model.
   * @param contractModelGroupId The id of the contract model to update.
   * @param body (optional) The request containing the flags indicating which fields to update and the new values.
   * @return OK
   */
  update(
    contractModelGroupId: number,

    body?: UpdateContractModelGroupRequest | undefined,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/contract-model-groups/{contractModelGroupId}';
    if (contractModelGroupId === undefined || contractModelGroupId === null)
      throw new Error("The parameter 'contractModelGroupId' must be defined.");
    url_ = url_.replace('{contractModelGroupId}', encodeURIComponent('' + contractModelGroupId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'patch',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('patch', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processUpdate(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processUpdate(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Deletes a contract model.
   * @param contractModelGroupId The id of the contract model to delete.
   * @return OK
   */
  delete(contractModelGroupId: number, options?: RequestOptions): Observable<void> {
    let url_ = this.baseUrl + '/contract-model-groups/{contractModelGroupId}';
    if (contractModelGroupId === undefined || contractModelGroupId === null)
      throw new Error("The parameter 'contractModelGroupId' must be defined.");
    url_ = url_.replace('{contractModelGroupId}', encodeURIComponent('' + contractModelGroupId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'delete',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processDelete(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  private handleError(error: any, options?: RequestOptions) {
    if (options && options.handleError === false) {
      throw error;
    }

    this.toastService.showToast({
      type: ToastType.Error,
      text: error.message,
      duration: 5,
    });

    return _observableOf(null);
  }
}

@Injectable()
export class ContractModelQuestionsClient {
  private http = inject(HttpClient);
  private toastService = inject(ToastService);
  private apiBaseUrl = inject(apiBaseUrl, { optional: true });
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    this.baseUrl = this.apiBaseUrl ?? 'https://expert.dev.instaclause.com/api';
  }

  /**
   * Retrieves the questions associated with a specific contract model.
   * @param contractModelId The id of the contract model.
   * @param languageId The id of the language to retrieve the questions in.
   * @return OK
   */
  getQuestions(
    contractModelId: number,

    languageId: number,
    options?: RequestOptions
  ): Observable<GetContractModelQuestionsResponse> {
    let url_ = this.baseUrl + '/contract-models/{contractModelId}/questions?';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetQuestions(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetQuestions(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(
                  e,
                  options
                ) as any as Observable<GetContractModelQuestionsResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<GetContractModelQuestionsResponse>;
          }
        })
      );
  }

  protected processGetQuestions(
    response: HttpResponseBase
  ): Observable<GetContractModelQuestionsResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as GetContractModelQuestionsResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetContractModelQuestionsResponse>(null as any);
  }

  /**
   * Creates a new question for a contract model.
   * @param contractModelId The id of the contract model.
   * @param body (optional) The request containing the question details.
   * @return OK
   */
  createQuestions(
    contractModelId: number,

    body?: CreateContractModelQuestionRequest | undefined,
    options?: RequestOptions
  ): Observable<CreateContractModelQuestionResponse> {
    let url_ = this.baseUrl + '/contract-models/{contractModelId}/questions';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateQuestions(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateQuestions(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(
                  e,
                  options
                ) as any as Observable<CreateContractModelQuestionResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<CreateContractModelQuestionResponse>;
          }
        })
      );
  }

  protected processCreateQuestions(
    response: HttpResponseBase
  ): Observable<CreateContractModelQuestionResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as CreateContractModelQuestionResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CreateContractModelQuestionResponse>(null as any);
  }

  /**
   * Deletes a question.
   * @param contractModelId The id of the contract model containing the question to delete.
   * @param questionId The id of the question to delete.
   * @return OK
   */
  deleteQuestions(
    contractModelId: number,

    questionId: number,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/contract-models/{contractModelId}/questions/{questionId}';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (questionId === undefined || questionId === null)
      throw new Error("The parameter 'questionId' must be defined.");
    url_ = url_.replace('{questionId}', encodeURIComponent('' + questionId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'delete',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteQuestions(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processDeleteQuestions(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processDeleteQuestions(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Updates the order of a question.
   * @param contractModelId The ID of the contract model containing the question.
   * @param questionId The ID of the question to update.
   * @param body (optional) The request containing the new order.
   * @return OK
   */
  updateQuestions(
    contractModelId: number,

    questionId: number,

    body?: UpdateQuestionRequest | undefined,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/contract-models/{contractModelId}/questions/{questionId}';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (questionId === undefined || questionId === null)
      throw new Error("The parameter 'questionId' must be defined.");
    url_ = url_.replace('{questionId}', encodeURIComponent('' + questionId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'patch',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('patch', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateQuestions(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processUpdateQuestions(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processUpdateQuestions(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  private handleError(error: any, options?: RequestOptions) {
    if (options && options.handleError === false) {
      throw error;
    }

    this.toastService.showToast({
      type: ToastType.Error,
      text: error.message,
      duration: 5,
    });

    return _observableOf(null);
  }
}

@Injectable()
export class ContractModelRolesClient {
  private http = inject(HttpClient);
  private toastService = inject(ToastService);
  private apiBaseUrl = inject(apiBaseUrl, { optional: true });
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    this.baseUrl = this.apiBaseUrl ?? 'https://expert.dev.instaclause.com/api';
  }

  /**
   * Retrieves the roles associated with a specific contract model.
   * @param contractModelId The identifier of the contract model.
   * @param languageId The identifier of the language to retrieve the roles in.
   * @return OK
   */
  getRoles(
    contractModelId: number,

    languageId: number,
    options?: RequestOptions
  ): Observable<GetContractModelRolesResponse> {
    let url_ = this.baseUrl + '/contract-models/{contractModelId}/roles?';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetRoles(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetRoles(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(
                  e,
                  options
                ) as any as Observable<GetContractModelRolesResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<GetContractModelRolesResponse>;
          }
        })
      );
  }

  protected processGetRoles(response: HttpResponseBase): Observable<GetContractModelRolesResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetContractModelRolesResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetContractModelRolesResponse>(null as any);
  }

  /**
   * Updates a role assignment.
   * @param contractModelId The id of the contract model containing the role assignment to update.
   * @param contractModelRoleId The id of the role assignment to update.
   * @param body (optional) The request containing the flags indicating which fields to update and the new values.
   * @return OK
   */
  updateRoles(
    contractModelId: number,

    contractModelRoleId: number,

    body?: UpdateContractModelRoleRequest | undefined,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/contract-models/{contractModelId}/roles/{contractModelRoleId}';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (contractModelRoleId === undefined || contractModelRoleId === null)
      throw new Error("The parameter 'contractModelRoleId' must be defined.");
    url_ = url_.replace('{contractModelRoleId}', encodeURIComponent('' + contractModelRoleId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'patch',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('patch', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateRoles(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processUpdateRoles(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processUpdateRoles(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Adds a condition to a role to be required in the contract model.
   * @param contractModelId The id of the contract model.
   * @param contractModelRoleId The id of the role assignment.
   * @param body (optional) The request containing the field id and the expected value.
   * @return OK
   */
  createRolesConditions(
    contractModelId: number,

    contractModelRoleId: number,

    body?: AddContractModelRoleConditionRequest | undefined,
    options?: RequestOptions
  ): Observable<void> {
    let url_ =
      this.baseUrl + '/contract-models/{contractModelId}/roles/{contractModelRoleId}/conditions';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (contractModelRoleId === undefined || contractModelRoleId === null)
      throw new Error("The parameter 'contractModelRoleId' must be defined.");
    url_ = url_.replace('{contractModelRoleId}', encodeURIComponent('' + contractModelRoleId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateRolesConditions(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateRolesConditions(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processCreateRolesConditions(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Deletes a condition from a role assignment.
   * @param contractModelId The id of the contract model.
   * @param contractModelRoleConditionId The id of the condition to delete.
   * @return OK
   */
  deleteRolesConditions(
    contractModelId: number,

    contractModelRoleConditionId: number,
    options?: RequestOptions
  ): Observable<void> {
    let url_ =
      this.baseUrl +
      '/contract-models/{contractModelId}/roles/conditions/{contractModelRoleConditionId}';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (contractModelRoleConditionId === undefined || contractModelRoleConditionId === null)
      throw new Error("The parameter 'contractModelRoleConditionId' must be defined.");
    url_ = url_.replace(
      '{contractModelRoleConditionId}',
      encodeURIComponent('' + contractModelRoleConditionId)
    );
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'delete',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteRolesConditions(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processDeleteRolesConditions(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processDeleteRolesConditions(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  private handleError(error: any, options?: RequestOptions) {
    if (options && options.handleError === false) {
      throw error;
    }

    this.toastService.showToast({
      type: ToastType.Error,
      text: error.message,
      duration: 5,
    });

    return _observableOf(null);
  }
}

@Injectable()
export class ContractModelsClient {
  private http = inject(HttpClient);
  private toastService = inject(ToastService);
  private apiBaseUrl = inject(apiBaseUrl, { optional: true });
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    this.baseUrl = this.apiBaseUrl ?? 'https://expert.dev.instaclause.com/api';
  }

  /**
   * Retrieves a list of available contract models.
   * @param languageId The id of the language to retrieve the contract models in.
   * @param query (optional)
   * @param sortBy (optional)
   * @param sortAscending (optional)
   * @param skip (optional)
   * @param take (optional)
   * @param deleted (optional) A flag indicating whether to query soft-deleted contracts.
   * @return OK
   */
  get(
    languageId: number,

    query?: string | undefined,

    sortBy?: string | undefined,

    sortAscending?: boolean | undefined,

    skip?: number | undefined,

    take?: number | undefined,

    deleted?: boolean | undefined,
    options?: RequestOptions
  ): Observable<GetContractModelsResponse> {
    let url_ = this.baseUrl + '/contract-models?';
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    if (query === null) throw new Error("The parameter 'query' cannot be null.");
    else if (query !== undefined) url_ += 'query=' + encodeURIComponent('' + query) + '&';
    if (sortBy === null) throw new Error("The parameter 'sortBy' cannot be null.");
    else if (sortBy !== undefined) url_ += 'sortBy=' + encodeURIComponent('' + sortBy) + '&';
    if (sortAscending === null) throw new Error("The parameter 'sortAscending' cannot be null.");
    else if (sortAscending !== undefined)
      url_ += 'sortAscending=' + encodeURIComponent('' + sortAscending) + '&';
    if (skip === null) throw new Error("The parameter 'skip' cannot be null.");
    else if (skip !== undefined) url_ += 'skip=' + encodeURIComponent('' + skip) + '&';
    if (take === null) throw new Error("The parameter 'take' cannot be null.");
    else if (take !== undefined) url_ += 'take=' + encodeURIComponent('' + take) + '&';
    if (deleted === null) throw new Error("The parameter 'deleted' cannot be null.");
    else if (deleted !== undefined) url_ += 'deleted=' + encodeURIComponent('' + deleted) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGet(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<GetContractModelsResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<GetContractModelsResponse>;
          }
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<GetContractModelsResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetContractModelsResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetContractModelsResponse>(null as any);
  }

  /**
   * Creates a new contract model.
   * @param body (optional) The request containing the name of the contract model.
   * @return OK
   */
  create(
    body?: CreateContractModelRequest | undefined,
    options?: RequestOptions
  ): Observable<CreateContractModelResponse> {
    let url_ = this.baseUrl + '/contract-models';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreate(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(
                  e,
                  options
                ) as any as Observable<CreateContractModelResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<CreateContractModelResponse>;
          }
        })
      );
  }

  protected processCreate(response: HttpResponseBase): Observable<CreateContractModelResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as CreateContractModelResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CreateContractModelResponse>(null as any);
  }

  /**
   * Retrieves a specific contract model.
   * @param contractModelId The id of the contract model to retrieve.
   * @param languageId The id of the language to retrieve the contract model in.
   * @return OK
   */
  getById(
    contractModelId: number,

    languageId: number,
    options?: RequestOptions
  ): Observable<GetContractModelResponse> {
    let url_ = this.baseUrl + '/contract-models/{contractModelId}?';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetById(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetById(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<GetContractModelResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<GetContractModelResponse>;
          }
        })
      );
  }

  protected processGetById(response: HttpResponseBase): Observable<GetContractModelResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetContractModelResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetContractModelResponse>(null as any);
  }

  /**
   * Updates a contract model.
   * @param contractModelId The id of the contract model to update.
   * @param force (optional)
   * @param body (optional) The request containing the flags indicating which fields to update and the new values.
   * @return OK
   */
  update(
    contractModelId: number,

    force?: boolean | undefined,

    body?: UpdateContractModelRequest | undefined,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/contract-models/{contractModelId}?';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (force === null) throw new Error("The parameter 'force' cannot be null.");
    else if (force !== undefined) url_ += 'force=' + encodeURIComponent('' + force) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'patch',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('patch', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processUpdate(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processUpdate(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Deletes a contract model.
   * @param contractModelId The id of the contract model to delete.
   * @param permanently (optional) A flag indicating whether to force the deletion of the contract.
   * @param force (optional)
   * @return OK
   */
  delete(
    contractModelId: number,

    permanently?: boolean | undefined,

    force?: boolean | undefined,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/contract-models/{contractModelId}?';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (permanently === null) throw new Error("The parameter 'permanently' cannot be null.");
    else if (permanently !== undefined)
      url_ += 'permanently=' + encodeURIComponent('' + permanently) + '&';
    if (force === null) throw new Error("The parameter 'force' cannot be null.");
    else if (force !== undefined) url_ += 'force=' + encodeURIComponent('' + force) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'delete',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processDelete(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Restores a soft-deleted contract model, making it available again in the system.
   * @param contractModelId The id of the contract model to restore.
   * @return OK
   */
  createRestore(contractModelId: number, options?: RequestOptions): Observable<void> {
    let url_ = this.baseUrl + '/contract-models/{contractModelId}/restore';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateRestore(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateRestore(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processCreateRestore(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Clones a contract model.
   * @param contractModelId The id of the contract model to clone.
   * @return OK
   */
  createClone(
    contractModelId: number,
    options?: RequestOptions
  ): Observable<CloneContractModelResponse> {
    let url_ = this.baseUrl + '/contract-models/{contractModelId}/clone';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateClone(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateClone(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(
                  e,
                  options
                ) as any as Observable<CloneContractModelResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<CloneContractModelResponse>;
          }
        })
      );
  }

  protected processCreateClone(response: HttpResponseBase): Observable<CloneContractModelResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as CloneContractModelResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CloneContractModelResponse>(null as any);
  }

  /**
   * Exports a contract model to JSON file.
   * @param contractModelId The id of the contract model to export.
   * @return OK
   */
  getExport(contractModelId: number, options?: RequestOptions): Observable<string> {
    let url_ = this.baseUrl + '/contract-models/{contractModelId}/export';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetExport(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetExport(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<string>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<string>;
          }
        })
      );
  }

  protected processGetExport(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<string>(null as any);
  }

  /**
   * Converts an uploaded JSON file into an ExportContractModel object and Imports it to Database.
   * @param file (optional)
   * @return OK
   */
  createImport(
    file?: FileParameter | undefined,
    options?: RequestOptions
  ): Observable<ImportContractModelRequest> {
    let url_ = this.baseUrl + '/contract-models/import';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = new FormData();
    if (file === null || file === undefined)
      throw new Error("The parameter 'file' cannot be null.");
    else content_.append('file', file.data, file.fileName ? file.fileName : 'file');

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateImport(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateImport(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(
                  e,
                  options
                ) as any as Observable<ImportContractModelRequest>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<ImportContractModelRequest>;
          }
        })
      );
  }

  protected processCreateImport(
    response: HttpResponseBase
  ): Observable<ImportContractModelRequest> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as ImportContractModelRequest);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<ImportContractModelRequest>(null as any);
  }

  /**
   * Gets snapshots of a contract model.
   * @param contractModelId The id of the contract model.
   * @return OK
   */
  getSnapshots(
    contractModelId: number,
    options?: RequestOptions
  ): Observable<GetSnapshotsResponse> {
    let url_ = this.baseUrl + '/contract-models/{contractModelId}/snapshots';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetSnapshots(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetSnapshots(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<GetSnapshotsResponse>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<GetSnapshotsResponse>;
          }
        })
      );
  }

  protected processGetSnapshots(response: HttpResponseBase): Observable<GetSnapshotsResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetSnapshotsResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetSnapshotsResponse>(null as any);
  }

  /**
   * Creates a new snapsho.
   * @param contractModelId The id of the contract model.
   * @param languageId The id of the language to compile the documents in.
   * @param force (optional) Whether to force creation of the snapshot even if one already exists.
   * @param body (optional) The request containing the description of the snapshot.
   * @return OK
   */
  createSnapshots(
    contractModelId: number,

    languageId: number,

    force?: boolean | undefined,

    body?: CreateSnapshotRequest | undefined,
    options?: RequestOptions
  ): Observable<CreateSnapshotResponse> {
    let url_ = this.baseUrl + '/contract-models/{contractModelId}/snapshots/{languageId}?';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined.");
    url_ = url_.replace('{languageId}', encodeURIComponent('' + languageId));
    if (force === null) throw new Error("The parameter 'force' cannot be null.");
    else if (force !== undefined) url_ += 'force=' + encodeURIComponent('' + force) + '&';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateSnapshots(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateSnapshots(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<CreateSnapshotResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<CreateSnapshotResponse>;
          }
        })
      );
  }

  protected processCreateSnapshots(response: HttpResponseBase): Observable<CreateSnapshotResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as CreateSnapshotResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CreateSnapshotResponse>(null as any);
  }

  /**
   * Updates a snapshot.
   * @param contractModelId The id of the contract model.
   * @param snapshotId The id of the snapshot to update.
   * @param body (optional) The request containing the new data of the document.
   * @return OK
   */
  updateSnapshots(
    contractModelId: number,

    snapshotId: number,

    body?: UpdateSnapshotRequest | undefined,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/contract-models/{contractModelId}/snapshots/{snapshotId}';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (snapshotId === undefined || snapshotId === null)
      throw new Error("The parameter 'snapshotId' must be defined.");
    url_ = url_.replace('{snapshotId}', encodeURIComponent('' + snapshotId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'patch',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('patch', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateSnapshots(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processUpdateSnapshots(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processUpdateSnapshots(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Deletes a snapshot.
   * @param contractModelId The id of the contract model.
   * @param snapshotId The id of the snapshot to delete.
   * @return OK
   */
  deleteSnapshots(
    contractModelId: number,

    snapshotId: number,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/contract-models/{contractModelId}/snapshots/{snapshotId}';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (snapshotId === undefined || snapshotId === null)
      throw new Error("The parameter 'snapshotId' must be defined.");
    url_ = url_.replace('{snapshotId}', encodeURIComponent('' + snapshotId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'delete',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteSnapshots(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processDeleteSnapshots(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processDeleteSnapshots(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  private handleError(error: any, options?: RequestOptions) {
    if (options && options.handleError === false) {
      throw error;
    }

    this.toastService.showToast({
      type: ToastType.Error,
      text: error.message,
      duration: 5,
    });

    return _observableOf(null);
  }
}

@Injectable()
export class ContractModelTagsClient {
  private http = inject(HttpClient);
  private toastService = inject(ToastService);
  private apiBaseUrl = inject(apiBaseUrl, { optional: true });
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    this.baseUrl = this.apiBaseUrl ?? 'https://expert.dev.instaclause.com/api';
  }

  /**
   * Retrieves the tags associated with a specific contract model.
   * @param contractModelId The id of the contract model.
   * @param languageId The id of the language to retrieve the tags in.
   * @return OK
   */
  getTags(
    contractModelId: number,

    languageId: number,
    options?: RequestOptions
  ): Observable<GetContractModelTagsResponse> {
    let url_ = this.baseUrl + '/contract-models/{contractModelId}/tags?';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetTags(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetTags(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(
                  e,
                  options
                ) as any as Observable<GetContractModelTagsResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<GetContractModelTagsResponse>;
          }
        })
      );
  }

  protected processGetTags(response: HttpResponseBase): Observable<GetContractModelTagsResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetContractModelTagsResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetContractModelTagsResponse>(null as any);
  }

  /**
   * Creates a new tag.
   * @param contractModelId The id of the contract model.
   * @param body (optional) The request with the tag data.
   * @return OK
   */
  createTags(
    contractModelId: number,

    body?: CreateTagRequest | undefined,
    options?: RequestOptions
  ): Observable<CreateTagResponse> {
    let url_ = this.baseUrl + '/contract-models/{contractModelId}/tags';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateTags(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateTags(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<CreateTagResponse>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<CreateTagResponse>;
          }
        })
      );
  }

  protected processCreateTags(response: HttpResponseBase): Observable<CreateTagResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as CreateTagResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CreateTagResponse>(null as any);
  }

  /**
   * Gets a tag by its id.
   * @param contractModelId The id of the contract model.
   * @param tagId The tag id.
   * @param languageId The language id.
   * @return OK
   */
  getById(
    contractModelId: number,

    tagId: number,

    languageId: number,
    options?: RequestOptions
  ): Observable<GetTagResponse> {
    let url_ = this.baseUrl + '/contract-models/{contractModelId}/tags/{tagId}?';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (tagId === undefined || tagId === null)
      throw new Error("The parameter 'tagId' must be defined.");
    url_ = url_.replace('{tagId}', encodeURIComponent('' + tagId));
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetById(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetById(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<GetTagResponse>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<GetTagResponse>;
          }
        })
      );
  }

  protected processGetById(response: HttpResponseBase): Observable<GetTagResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetTagResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetTagResponse>(null as any);
  }

  /**
   * Updates a tag.
   * @param contractModelId The id of the contract model.
   * @param tagId The tag id.
   * @param body (optional) The request with the tag data to update.
   * @return OK
   */
  updateTags(
    contractModelId: number,

    tagId: number,

    body?: UpdateTagRequest | undefined,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/contract-models/{contractModelId}/tags/{tagId}';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (tagId === undefined || tagId === null)
      throw new Error("The parameter 'tagId' must be defined.");
    url_ = url_.replace('{tagId}', encodeURIComponent('' + tagId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'patch',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('patch', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateTags(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processUpdateTags(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processUpdateTags(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Deletes a tag.
   * @param contractModelId The id of the contract model.
   * @param tagId The tag id.
   * @return OK
   */
  deleteTags(
    contractModelId: number,

    tagId: number,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/contract-models/{contractModelId}/tags/{tagId}';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (tagId === undefined || tagId === null)
      throw new Error("The parameter 'tagId' must be defined.");
    url_ = url_.replace('{tagId}', encodeURIComponent('' + tagId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'delete',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteTags(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processDeleteTags(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processDeleteTags(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Gets all branches of a tag.
   * @param contractModelId The id of the contract model.
   * @param tagId The tag id.
   * @return OK
   */
  getTagsBranches(
    contractModelId: number,

    tagId: number,
    options?: RequestOptions
  ): Observable<GetTagBranchesResponse> {
    let url_ = this.baseUrl + '/contract-models/{contractModelId}/tags/{tagId}/branches';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (tagId === undefined || tagId === null)
      throw new Error("The parameter 'tagId' must be defined.");
    url_ = url_.replace('{tagId}', encodeURIComponent('' + tagId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetTagsBranches(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetTagsBranches(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<GetTagBranchesResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<GetTagBranchesResponse>;
          }
        })
      );
  }

  protected processGetTagsBranches(response: HttpResponseBase): Observable<GetTagBranchesResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetTagBranchesResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetTagBranchesResponse>(null as any);
  }

  /**
   * Creates a new tag branch.
   * @param contractModelId The id of the contract model.
   * @param tagId The tag id to add the branch.
   * @param body (optional) The request with the branch data.
   * @return OK
   */
  createTagsBranches(
    contractModelId: number,

    tagId: number,

    body?: CreateTagBranchRequest | undefined,
    options?: RequestOptions
  ): Observable<CreateTagBranchResponse> {
    let url_ = this.baseUrl + '/contract-models/{contractModelId}/tags/{tagId}/branches';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (tagId === undefined || tagId === null)
      throw new Error("The parameter 'tagId' must be defined.");
    url_ = url_.replace('{tagId}', encodeURIComponent('' + tagId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateTagsBranches(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateTagsBranches(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<CreateTagBranchResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<CreateTagBranchResponse>;
          }
        })
      );
  }

  protected processCreateTagsBranches(
    response: HttpResponseBase
  ): Observable<CreateTagBranchResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as CreateTagBranchResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CreateTagBranchResponse>(null as any);
  }

  /**
   * Updates a tag branch.
   * @param contractModelId The id of the contract model.
   * @param branchId The branch id.
   * @param body (optional) The request with the branch data to update.
   * @return OK
   */
  updateTagsBranches(
    contractModelId: number,

    branchId: number,

    body?: UpdateTagBranchRequest | undefined,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/contract-models/{contractModelId}/tags/branches/{branchId}';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (branchId === undefined || branchId === null)
      throw new Error("The parameter 'branchId' must be defined.");
    url_ = url_.replace('{branchId}', encodeURIComponent('' + branchId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'patch',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('patch', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateTagsBranches(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processUpdateTagsBranches(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processUpdateTagsBranches(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Deletes a tag branch.
   * @param contractModelId The id of the contract model.
   * @param branchId The branch id.
   * @return OK
   */
  deleteTagsBranches(
    contractModelId: number,

    branchId: number,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/contract-models/{contractModelId}/tags/branches/{branchId}';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (branchId === undefined || branchId === null)
      throw new Error("The parameter 'branchId' must be defined.");
    url_ = url_.replace('{branchId}', encodeURIComponent('' + branchId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'delete',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteTagsBranches(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processDeleteTagsBranches(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processDeleteTagsBranches(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Updates the template of a tag branch.
   * @param contractModelId The id of the contract model.
   * @param branchId The branch id.
   * @param templateTranslationId The template translation id.
   * @param body (optional) The request with the template data to update.
   * @return OK
   */
  updateTagsBranchesTemplate(
    contractModelId: number,

    branchId: number,

    templateTranslationId: number,

    body?: UpdateTemplateRequest | undefined,
    options?: RequestOptions
  ): Observable<void> {
    let url_ =
      this.baseUrl +
      '/contract-models/{contractModelId}/tags/branches/{branchId}/template/{templateTranslationId}';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (branchId === undefined || branchId === null)
      throw new Error("The parameter 'branchId' must be defined.");
    url_ = url_.replace('{branchId}', encodeURIComponent('' + branchId));
    if (templateTranslationId === undefined || templateTranslationId === null)
      throw new Error("The parameter 'templateTranslationId' must be defined.");
    url_ = url_.replace('{templateTranslationId}', encodeURIComponent('' + templateTranslationId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'put',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('put', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateTagsBranchesTemplate(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processUpdateTagsBranchesTemplate(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processUpdateTagsBranchesTemplate(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  private handleError(error: any, options?: RequestOptions) {
    if (options && options.handleError === false) {
      throw error;
    }

    this.toastService.showToast({
      type: ToastType.Error,
      text: error.message,
      duration: 5,
    });

    return _observableOf(null);
  }
}

@Injectable()
export class CustomerThemeClient {
  private http = inject(HttpClient);
  private toastService = inject(ToastService);
  private apiBaseUrl = inject(apiBaseUrl, { optional: true });
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    this.baseUrl = this.apiBaseUrl ?? 'https://expert.dev.instaclause.com/api';
  }

  /**
   * Retrieves the customer templates.
   * @return OK
   */
  get(options?: RequestOptions): Observable<GetCustomerThemeResponse> {
    let url_ = this.baseUrl + '/customer-theme';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGet(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<GetCustomerThemeResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<GetCustomerThemeResponse>;
          }
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<GetCustomerThemeResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetCustomerThemeResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetCustomerThemeResponse>(null as any);
  }

  /**
   * Updates the customer theme.
   * @param body (optional) The request containing customer templates to update.
   * @return OK
   */
  update(
    body?: UpdateCustomerThemeRequest | undefined,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/customer-theme';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'patch',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('patch', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processUpdate(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processUpdate(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  private handleError(error: any, options?: RequestOptions) {
    if (options && options.handleError === false) {
      throw error;
    }

    this.toastService.showToast({
      type: ToastType.Error,
      text: error.message,
      duration: 5,
    });

    return _observableOf(null);
  }
}

@Injectable()
export class DocumentsClient {
  private http = inject(HttpClient);
  private toastService = inject(ToastService);
  private apiBaseUrl = inject(apiBaseUrl, { optional: true });
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    this.baseUrl = this.apiBaseUrl ?? 'https://expert.dev.instaclause.com/api';
  }

  /**
   * Gets a document by id.
   * @param documentId The id of the document.
   * @param languageId The id of the language.
   * @return OK
   */
  getById(
    contractModelId: number,

    documentId: number,

    languageId: number,
    options?: RequestOptions
  ): Observable<GetDocumentResponse> {
    let url_ = this.baseUrl + '/contract-models/{contractModelId}/documents/{documentId}?';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId));
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetById(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetById(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<GetDocumentResponse>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<GetDocumentResponse>;
          }
        })
      );
  }

  protected processGetById(response: HttpResponseBase): Observable<GetDocumentResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetDocumentResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetDocumentResponse>(null as any);
  }

  /**
   * Updates a document.
   * @param documentId The id of the document to update.
   * @param body (optional) The request containing the new data of the document.
   * @return OK
   */
  updateDocuments(
    contractModelId: number,

    documentId: number,

    body?: UpdateDocumentRequest | undefined,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/contract-models/{contractModelId}/documents/{documentId}';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'patch',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('patch', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateDocuments(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processUpdateDocuments(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processUpdateDocuments(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Deletes a document.
   * @param documentId The id of the document to delete.
   * @return OK
   */
  deleteDocuments(
    contractModelId: number,

    documentId: number,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/contract-models/{contractModelId}/documents/{documentId}';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'delete',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteDocuments(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processDeleteDocuments(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processDeleteDocuments(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Gets the documents associated with a specific contract model.
   * @param contractModelId The id of the contract model.
   * @param languageId The id of the language to retrieve the documents in.
   * @return OK
   */
  getDocuments(
    contractModelId: number,

    languageId: number,
    options?: RequestOptions
  ): Observable<GetContractModelDocumentsResponse> {
    let url_ = this.baseUrl + '/contract-models/{contractModelId}/documents?';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetDocuments(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetDocuments(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(
                  e,
                  options
                ) as any as Observable<GetContractModelDocumentsResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<GetContractModelDocumentsResponse>;
          }
        })
      );
  }

  protected processGetDocuments(
    response: HttpResponseBase
  ): Observable<GetContractModelDocumentsResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as GetContractModelDocumentsResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetContractModelDocumentsResponse>(null as any);
  }

  /**
   * Creates a new document.
   * @param body (optional) The request containing data of the new document.
   * @return OK
   */
  createDocuments(
    contractModelId: number,

    body?: CreateDocumentRequest | undefined,
    options?: RequestOptions
  ): Observable<CreateDocumentResponse> {
    let url_ = this.baseUrl + '/contract-models/{contractModelId}/documents';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateDocuments(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateDocuments(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<CreateDocumentResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<CreateDocumentResponse>;
          }
        })
      );
  }

  protected processCreateDocuments(response: HttpResponseBase): Observable<CreateDocumentResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as CreateDocumentResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CreateDocumentResponse>(null as any);
  }

  /**
   * Adds a clause to a document.
   * @param documentId The id of the document.
   * @param body (optional) The request containing the data of the clause and the order.
   * @return OK
   */
  createDocumentsClauses(
    contractModelId: number,

    documentId: number,

    body?: AddDocumentClauseRequest | undefined,
    options?: RequestOptions
  ): Observable<AddDocumentClauseResponse> {
    let url_ = this.baseUrl + '/contract-models/{contractModelId}/documents/{documentId}/clauses';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateDocumentsClauses(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateDocumentsClauses(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<AddDocumentClauseResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<AddDocumentClauseResponse>;
          }
        })
      );
  }

  protected processCreateDocumentsClauses(
    response: HttpResponseBase
  ): Observable<AddDocumentClauseResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as AddDocumentClauseResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<AddDocumentClauseResponse>(null as any);
  }

  /**
   * Removes a clause from a document.
   * @param documentClauseId The id of the document clause to remove.
   * @return OK
   */
  deleteDocumentsClauses(
    contractModelId: number,

    documentClauseId: number,
    options?: RequestOptions
  ): Observable<void> {
    let url_ =
      this.baseUrl + '/contract-models/{contractModelId}/documents/clauses/{documentClauseId}';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (documentClauseId === undefined || documentClauseId === null)
      throw new Error("The parameter 'documentClauseId' must be defined.");
    url_ = url_.replace('{documentClauseId}', encodeURIComponent('' + documentClauseId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'delete',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteDocumentsClauses(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processDeleteDocumentsClauses(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processDeleteDocumentsClauses(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Updates the order of the document clauses.
   * @param documentId The id of the document.
   * @param body (optional) The request containing the position and the new position of the clause group.
   * @return OK
   */
  updateDocumentsOrder(
    contractModelId: number,

    documentId: number,

    body?: UpdateDocumentClausesOrderRequest | undefined,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/contract-models/{contractModelId}/documents/{documentId}/order';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'patch',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('patch', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateDocumentsOrder(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processUpdateDocumentsOrder(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processUpdateDocumentsOrder(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Creates a new document clause variation.
   * @param documentClauseId The id of the document clause to create a variation of.
   * @param body (optional) The request containing the new variation data.
   * @return OK
   */
  createDocumentsClausesVariations(
    contractModelId: number,

    documentClauseId: number,

    body?: CreateDocumentClauseVariationRequest | undefined,
    options?: RequestOptions
  ): Observable<CreateDocumentClauseVariationResponse> {
    let url_ =
      this.baseUrl +
      '/contract-models/{contractModelId}/documents/clauses/{documentClauseId}/variations';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (documentClauseId === undefined || documentClauseId === null)
      throw new Error("The parameter 'documentClauseId' must be defined.");
    url_ = url_.replace('{documentClauseId}', encodeURIComponent('' + documentClauseId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateDocumentsClausesVariations(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateDocumentsClausesVariations(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(
                  e,
                  options
                ) as any as Observable<CreateDocumentClauseVariationResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<CreateDocumentClauseVariationResponse>;
          }
        })
      );
  }

  protected processCreateDocumentsClausesVariations(
    response: HttpResponseBase
  ): Observable<CreateDocumentClauseVariationResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as CreateDocumentClauseVariationResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CreateDocumentClauseVariationResponse>(null as any);
  }

  /**
   * Adds a condition to a document clause.
   * @param documentClauseId The id of the document clause to add.
   * @param body (optional) The request containing the condition data.
   * @return OK
   */
  createDocumentsClausesConditions(
    contractModelId: number,

    documentClauseId: number,

    body?: CreateDocumentClauseConditionRequest | undefined,
    options?: RequestOptions
  ): Observable<CreateDocumentClauseConditionResponse> {
    let url_ =
      this.baseUrl +
      '/contract-models/{contractModelId}/documents/clauses/{documentClauseId}/conditions';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (documentClauseId === undefined || documentClauseId === null)
      throw new Error("The parameter 'documentClauseId' must be defined.");
    url_ = url_.replace('{documentClauseId}', encodeURIComponent('' + documentClauseId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateDocumentsClausesConditions(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateDocumentsClausesConditions(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(
                  e,
                  options
                ) as any as Observable<CreateDocumentClauseConditionResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<CreateDocumentClauseConditionResponse>;
          }
        })
      );
  }

  protected processCreateDocumentsClausesConditions(
    response: HttpResponseBase
  ): Observable<CreateDocumentClauseConditionResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(
                  _responseText,
                  this.jsonParseReviver
                ) as CreateDocumentClauseConditionResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CreateDocumentClauseConditionResponse>(null as any);
  }

  /**
   * Removes a condition from a document clause.
   * @param conditionId The id of the condition to remove.
   * @return OK
   */
  deleteDocumentsClausesConditions(
    contractModelId: number,

    conditionId: number,
    options?: RequestOptions
  ): Observable<void> {
    let url_ =
      this.baseUrl +
      '/contract-models/{contractModelId}/documents/clauses/conditions/{conditionId}';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (conditionId === undefined || conditionId === null)
      throw new Error("The parameter 'conditionId' must be defined.");
    url_ = url_.replace('{conditionId}', encodeURIComponent('' + conditionId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'delete',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteDocumentsClausesConditions(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processDeleteDocumentsClausesConditions(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processDeleteDocumentsClausesConditions(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Updates a condition of a document clause.
   * @param conditionId The id of the condition to update.
   * @param body (optional) The request containing the new condition data.
   * @return OK
   */
  updateDocumentsClausesConditions(
    contractModelId: number,

    conditionId: number,

    body?: UpdateDocumentClauseConditionRequest | undefined,
    options?: RequestOptions
  ): Observable<void> {
    let url_ =
      this.baseUrl +
      '/contract-models/{contractModelId}/documents/clauses/conditions/{conditionId}';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (conditionId === undefined || conditionId === null)
      throw new Error("The parameter 'conditionId' must be defined.");
    url_ = url_.replace('{conditionId}', encodeURIComponent('' + conditionId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'patch',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('patch', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateDocumentsClausesConditions(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processUpdateDocumentsClausesConditions(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processUpdateDocumentsClausesConditions(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
     * Gets all fields used in templates that indirectly references the document. Useful when adding a existing
    field to a template.
     * @param documentId The id of the document.
     * @param languageId The id of the language.
     * @return OK
     */
  getDocumentsFields(
    contractModelId: number,

    documentId: number,

    languageId: number,
    options?: RequestOptions
  ): Observable<GetDocumentFieldsResponse> {
    let url_ = this.baseUrl + '/contract-models/{contractModelId}/documents/{documentId}/fields?';
    if (contractModelId === undefined || contractModelId === null)
      throw new Error("The parameter 'contractModelId' must be defined.");
    url_ = url_.replace('{contractModelId}', encodeURIComponent('' + contractModelId));
    if (documentId === undefined || documentId === null)
      throw new Error("The parameter 'documentId' must be defined.");
    url_ = url_.replace('{documentId}', encodeURIComponent('' + documentId));
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetDocumentsFields(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetDocumentsFields(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<GetDocumentFieldsResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<GetDocumentFieldsResponse>;
          }
        })
      );
  }

  protected processGetDocumentsFields(
    response: HttpResponseBase
  ): Observable<GetDocumentFieldsResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetDocumentFieldsResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetDocumentFieldsResponse>(null as any);
  }

  private handleError(error: any, options?: RequestOptions) {
    if (options && options.handleError === false) {
      throw error;
    }

    this.toastService.showToast({
      type: ToastType.Error,
      text: error.message,
      duration: 5,
    });

    return _observableOf(null);
  }
}

@Injectable()
export class FieldsClient {
  private http = inject(HttpClient);
  private toastService = inject(ToastService);
  private apiBaseUrl = inject(apiBaseUrl, { optional: true });
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    this.baseUrl = this.apiBaseUrl ?? 'https://expert.dev.instaclause.com/api';
  }

  /**
   * Gets details of a field by id.
   * @param fieldId The field id.
   * @param languageId The language id.
   * @return OK
   */
  getById(
    fieldId: number,

    languageId: number,
    options?: RequestOptions
  ): Observable<GetFieldResponse> {
    let url_ = this.baseUrl + '/fields/{fieldId}?';
    if (fieldId === undefined || fieldId === null)
      throw new Error("The parameter 'fieldId' must be defined.");
    url_ = url_.replace('{fieldId}', encodeURIComponent('' + fieldId));
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetById(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetById(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<GetFieldResponse>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<GetFieldResponse>;
          }
        })
      );
  }

  protected processGetById(response: HttpResponseBase): Observable<GetFieldResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetFieldResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetFieldResponse>(null as any);
  }

  private handleError(error: any, options?: RequestOptions) {
    if (options && options.handleError === false) {
      throw error;
    }

    this.toastService.showToast({
      type: ToastType.Error,
      text: error.message,
      duration: 5,
    });

    return _observableOf(null);
  }
}

@Injectable()
export class LanguagesClient {
  private http = inject(HttpClient);
  private toastService = inject(ToastService);
  private apiBaseUrl = inject(apiBaseUrl, { optional: true });
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    this.baseUrl = this.apiBaseUrl ?? 'https://expert.dev.instaclause.com/api';
  }

  /**
   * Gets the language by its id.
   * @param languageId The id of the language to retrieve.
   * @return OK
   */
  getById(languageId: number, options?: RequestOptions): Observable<GetLanguageResponse> {
    let url_ = this.baseUrl + '/languages/{languageId}';
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined.");
    url_ = url_.replace('{languageId}', encodeURIComponent('' + languageId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetById(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetById(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<GetLanguageResponse>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<GetLanguageResponse>;
          }
        })
      );
  }

  protected processGetById(response: HttpResponseBase): Observable<GetLanguageResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetLanguageResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetLanguageResponse>(null as any);
  }

  /**
   * Retrieves a list of languages.
   * @return OK
   */
  get(options?: RequestOptions): Observable<GetLanguagesResponse> {
    let url_ = this.baseUrl + '/languages';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGet(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<GetLanguagesResponse>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<GetLanguagesResponse>;
          }
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<GetLanguagesResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetLanguagesResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetLanguagesResponse>(null as any);
  }

  private handleError(error: any, options?: RequestOptions) {
    if (options && options.handleError === false) {
      throw error;
    }

    this.toastService.showToast({
      type: ToastType.Error,
      text: error.message,
      duration: 5,
    });

    return _observableOf(null);
  }
}

@Injectable()
export class PartyTypesClient {
  private http = inject(HttpClient);
  private toastService = inject(ToastService);
  private apiBaseUrl = inject(apiBaseUrl, { optional: true });
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    this.baseUrl = this.apiBaseUrl ?? 'https://expert.dev.instaclause.com/api';
  }

  /**
   * Gets all party types.
   * @param languageId The language id.
   * @return OK
   */
  get(languageId: number, options?: RequestOptions): Observable<GetPartyTypesResponse> {
    let url_ = this.baseUrl + '/party-types?';
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGet(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<GetPartyTypesResponse>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<GetPartyTypesResponse>;
          }
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<GetPartyTypesResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetPartyTypesResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetPartyTypesResponse>(null as any);
  }

  /**
   * Gets a party type by id.
   * @param partyType The party type id.
   * @param languageId The language id.
   * @return OK
   */
  getById(
    partyType: PartyTypeOptions,

    languageId: number,
    options?: RequestOptions
  ): Observable<GetPartyTypeResponse> {
    let url_ = this.baseUrl + '/party-types/{partyType}?';
    if (partyType === undefined || partyType === null)
      throw new Error("The parameter 'partyType' must be defined.");
    url_ = url_.replace('{partyType}', encodeURIComponent('' + partyType));
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetById(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetById(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<GetPartyTypeResponse>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<GetPartyTypeResponse>;
          }
        })
      );
  }

  protected processGetById(response: HttpResponseBase): Observable<GetPartyTypeResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetPartyTypeResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetPartyTypeResponse>(null as any);
  }

  /**
   * Updates a party type.
   * @param partyType The party type id.
   * @param body (optional) The request with the party type data to update.
   * @return OK
   */
  update(
    partyType: PartyTypeOptions,

    body?: UpdatePartyTypeRequest | undefined,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/party-types/{partyType}';
    if (partyType === undefined || partyType === null)
      throw new Error("The parameter 'partyType' must be defined.");
    url_ = url_.replace('{partyType}', encodeURIComponent('' + partyType));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'patch',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('patch', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processUpdate(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processUpdate(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Creates a new party type additional field.
   * @param partyType The party type id.
   * @param body (optional) The request with the party type additional field data.
   * @return OK
   */
  createFields(
    partyType: PartyTypeOptions,

    body?: AddPartyTypeFieldRequest | undefined,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/party-types/{partyType}/fields';
    if (partyType === undefined || partyType === null)
      throw new Error("The parameter 'partyType' must be defined.");
    url_ = url_.replace('{partyType}', encodeURIComponent('' + partyType));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreateFields(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreateFields(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processCreateFields(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Deletes a party type additional field.
   * @param partyTypeFieldId The party type additional field id.
   * @return OK
   */
  deleteFields(partyTypeFieldId: number, options?: RequestOptions): Observable<void> {
    let url_ = this.baseUrl + '/party-types/fields/{partyTypeFieldId}';
    if (partyTypeFieldId === undefined || partyTypeFieldId === null)
      throw new Error("The parameter 'partyTypeFieldId' must be defined.");
    url_ = url_.replace('{partyTypeFieldId}', encodeURIComponent('' + partyTypeFieldId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'delete',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteFields(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processDeleteFields(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processDeleteFields(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  private handleError(error: any, options?: RequestOptions) {
    if (options && options.handleError === false) {
      throw error;
    }

    this.toastService.showToast({
      type: ToastType.Error,
      text: error.message,
      duration: 5,
    });

    return _observableOf(null);
  }
}

@Injectable()
export class RolesClient {
  private http = inject(HttpClient);
  private toastService = inject(ToastService);
  private apiBaseUrl = inject(apiBaseUrl, { optional: true });
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    this.baseUrl = this.apiBaseUrl ?? 'https://expert.dev.instaclause.com/api';
  }

  /**
   * Gets all roles.
   * @param languageId The language id.
   * @return OK
   */
  get(languageId: number, options?: RequestOptions): Observable<GetRolesResponse> {
    let url_ = this.baseUrl + '/roles?';
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGet(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGet(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<GetRolesResponse>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<GetRolesResponse>;
          }
        })
      );
  }

  protected processGet(response: HttpResponseBase): Observable<GetRolesResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetRolesResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetRolesResponse>(null as any);
  }

  /**
   * Creates a new role.
   * @param body (optional) The request with the role data.
   * @return OK
   */
  create(
    body?: CreateRoleRequest | undefined,
    options?: RequestOptions
  ): Observable<CreateRoleResponse> {
    let url_ = this.baseUrl + '/roles';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreate(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreate(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<CreateRoleResponse>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<CreateRoleResponse>;
          }
        })
      );
  }

  protected processCreate(response: HttpResponseBase): Observable<CreateRoleResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as CreateRoleResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CreateRoleResponse>(null as any);
  }

  /**
   * Gets a role by id.
   * @param roleId The role id.
   * @param languageId The language id.
   * @return OK
   */
  getById(
    roleId: number,

    languageId: number,
    options?: RequestOptions
  ): Observable<GetRoleResponse> {
    let url_ = this.baseUrl + '/roles/{roleId}?';
    if (roleId === undefined || roleId === null)
      throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetById(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetById(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<GetRoleResponse>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<GetRoleResponse>;
          }
        })
      );
  }

  protected processGetById(response: HttpResponseBase): Observable<GetRoleResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetRoleResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetRoleResponse>(null as any);
  }

  /**
   * Updates a role.
   * @param roleId The role id.
   * @param body (optional) The request with the role data to update.
   * @return OK
   */
  update(
    roleId: number,

    body?: UpdateRoleRequest | undefined,
    options?: RequestOptions
  ): Observable<UpdateRoleResponse> {
    let url_ = this.baseUrl + '/roles/{roleId}';
    if (roleId === undefined || roleId === null)
      throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'patch',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('patch', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdate(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processUpdate(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<UpdateRoleResponse>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<UpdateRoleResponse>;
          }
        })
      );
  }

  protected processUpdate(response: HttpResponseBase): Observable<UpdateRoleResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as UpdateRoleResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<UpdateRoleResponse>(null as any);
  }

  /**
   * Deletes a role.
   * @param roleId The role id.
   * @return OK
   */
  delete(roleId: number, options?: RequestOptions): Observable<void> {
    let url_ = this.baseUrl + '/roles/{roleId}';
    if (roleId === undefined || roleId === null)
      throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'delete',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDelete(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processDelete(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processDelete(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Gets the available additional fields filtered by party types.
   * @param partyTypes Array of party types to filter default fields.
   * @param languageId The language id.
   * @return OK
   */
  getAvailableAdditionalFields(
    partyTypes: PartyTypeOptions[],

    languageId: number,
    options?: RequestOptions
  ): Observable<GetFieldsResponse> {
    let url_ = this.baseUrl + '/roles/available-additional-fields?';
    if (partyTypes === undefined || partyTypes === null)
      throw new Error("The parameter 'partyTypes' must be defined and cannot be null.");
    else
      partyTypes &&
        partyTypes.forEach((item) => {
          url_ += 'partyTypes=' + encodeURIComponent('' + item) + '&';
        });
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetAvailableAdditionalFields(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetAvailableAdditionalFields(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<GetFieldsResponse>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<GetFieldsResponse>;
          }
        })
      );
  }

  protected processGetAvailableAdditionalFields(
    response: HttpResponseBase
  ): Observable<GetFieldsResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetFieldsResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetFieldsResponse>(null as any);
  }

  /**
   * Gets the available fields for a role.
   * @param roleId The role id.
   * @param languageId The language id.
   * @return OK
   */
  getTemplateFields(
    roleId: number,

    languageId: number,
    options?: RequestOptions
  ): Observable<GetFieldsResponse> {
    let url_ = this.baseUrl + '/roles/{roleId}/template-fields?';
    if (roleId === undefined || roleId === null)
      throw new Error("The parameter 'roleId' must be defined.");
    url_ = url_.replace('{roleId}', encodeURIComponent('' + roleId));
    if (languageId === undefined || languageId === null)
      throw new Error("The parameter 'languageId' must be defined and cannot be null.");
    else url_ += 'languageId=' + encodeURIComponent('' + languageId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetTemplateFields(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetTemplateFields(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<GetFieldsResponse>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<GetFieldsResponse>;
          }
        })
      );
  }

  protected processGetTemplateFields(response: HttpResponseBase): Observable<GetFieldsResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetFieldsResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetFieldsResponse>(null as any);
  }

  /**
   * Creates a new party field.
   * @param body (optional) The request with the field data.
   * @return OK
   */
  createPartyField(
    body?: CreateFieldRequest | undefined,
    options?: RequestOptions
  ): Observable<CreateFieldResponse> {
    let url_ = this.baseUrl + '/roles/party-field';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'post',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('post', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processCreatePartyField(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processCreatePartyField(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<CreateFieldResponse>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<CreateFieldResponse>;
          }
        })
      );
  }

  protected processCreatePartyField(response: HttpResponseBase): Observable<CreateFieldResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as CreateFieldResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<CreateFieldResponse>(null as any);
  }

  private handleError(error: any, options?: RequestOptions) {
    if (options && options.handleError === false) {
      throw error;
    }

    this.toastService.showToast({
      type: ToastType.Error,
      text: error.message,
      duration: 5,
    });

    return _observableOf(null);
  }
}

@Injectable()
export class TemplatesClient {
  private http = inject(HttpClient);
  private toastService = inject(ToastService);
  private apiBaseUrl = inject(apiBaseUrl, { optional: true });
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

  constructor() {
    this.baseUrl = this.apiBaseUrl ?? 'https://expert.dev.instaclause.com/api';
  }

  /**
   * Retrieves all fragments of a template.
   * @param templateTranslationId The id of the template translation to retrieve.
   * @return OK
   */
  getFragments(
    templateTranslationId: number,
    options?: RequestOptions
  ): Observable<GetTemplateFragmentsResponse> {
    let url_ = this.baseUrl + '/templates/{templateTranslationId}/fragments';
    if (templateTranslationId === undefined || templateTranslationId === null)
      throw new Error("The parameter 'templateTranslationId' must be defined.");
    url_ = url_.replace('{templateTranslationId}', encodeURIComponent('' + templateTranslationId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetFragments(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetFragments(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(
                  e,
                  options
                ) as any as Observable<GetTemplateFragmentsResponse>;
              })
            );
          } else {
            return this.handleError(
              response_,
              options
            ) as any as Observable<GetTemplateFragmentsResponse>;
          }
        })
      );
  }

  protected processGetFragments(
    response: HttpResponseBase
  ): Observable<GetTemplateFragmentsResponse> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as GetTemplateFragmentsResponse);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<GetTemplateFragmentsResponse>(null as any);
  }

  /**
   * Retrieves the scriban representation of a template.
   * @param templateTranslationId The id of the template translation.
   * @return OK
   */
  getScriban(templateTranslationId: number, options?: RequestOptions): Observable<string> {
    let url_ = this.baseUrl + '/templates/{templateTranslationId}/scriban';
    if (templateTranslationId === undefined || templateTranslationId === null)
      throw new Error("The parameter 'templateTranslationId' must be defined.");
    url_ = url_.replace('{templateTranslationId}', encodeURIComponent('' + templateTranslationId));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'get',
      headers: new HttpHeaders({
        Accept: 'text/plain',
      }),
    };

    return this.http
      .request('get', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processGetScriban(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processGetScriban(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<string>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<string>;
          }
        })
      );
  }

  protected processGetScriban(response: HttpResponseBase): Observable<string> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          result200 =
            _responseText === ''
              ? null
              : (JSON.parse(_responseText, this.jsonParseReviver) as string);
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<string>(null as any);
  }

  /**
   * Deletes a fragment from a template.
   * @param templateTranslationId The id of the template translation.
   * @param order The order of the fragment to delete.
   * @return OK
   */
  deleteFragments(
    templateTranslationId: number,

    order: number,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/templates/{templateTranslationId}/fragments/{order}';
    if (templateTranslationId === undefined || templateTranslationId === null)
      throw new Error("The parameter 'templateTranslationId' must be defined.");
    url_ = url_.replace('{templateTranslationId}', encodeURIComponent('' + templateTranslationId));
    if (order === undefined || order === null)
      throw new Error("The parameter 'order' must be defined.");
    url_ = url_.replace('{order}', encodeURIComponent('' + order));
    url_ = url_.replace(/[?&]$/, '');

    let options_: any = {
      observe: 'response',
      responseType: 'blob',
      method: 'delete',
      headers: new HttpHeaders({}),
    };

    return this.http
      .request('delete', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processDeleteFragments(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processDeleteFragments(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processDeleteFragments(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  /**
   * Updates a role fragment.
   * @param roleFragmentId The id of the role fragment to update.
   * @param body (optional) The request containing the new data.
   * @return OK
   */
  updateRoles(
    roleFragmentId: number,

    body?: UpdateRoleFragmentRequest | undefined,
    options?: RequestOptions
  ): Observable<void> {
    let url_ = this.baseUrl + '/templates/roles/{roleFragmentId}';
    if (roleFragmentId === undefined || roleFragmentId === null)
      throw new Error("The parameter 'roleFragmentId' must be defined.");
    url_ = url_.replace('{roleFragmentId}', encodeURIComponent('' + roleFragmentId));
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(body);

    let options_: any = {
      body: content_,
      observe: 'response',
      responseType: 'blob',
      method: 'patch',
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
      }),
    };

    return this.http
      .request('patch', url_, options_)
      .pipe(
        _observableMergeMap((response_: any) => {
          return this.processUpdateRoles(response_);
        })
      )
      .pipe(
        catchError((response_: any) => {
          if (response_ instanceof HttpResponseBase) {
            return this.processUpdateRoles(response_ as any).pipe(
              catchError((e) => {
                return this.handleError(e, options) as any as Observable<void>;
              })
            );
          } else {
            return this.handleError(response_, options) as any as Observable<void>;
          }
        })
      );
  }

  protected processUpdateRoles(response: HttpResponseBase): Observable<void> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (response as any).error instanceof Blob
        ? (response as any).error
        : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return _observableOf<void>(null as any);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<void>(null as any);
  }

  private handleError(error: any, options?: RequestOptions) {
    if (options && options.handleError === false) {
      throw error;
    }

    this.toastService.showToast({
      type: ToastType.Error,
      text: error.message,
      duration: 5,
    });

    return _observableOf(null);
  }
}

/** Represents a request to add a condition to a role in a contract model. */
export interface AddContractModelRoleConditionRequest {
  /** The field id that the condition is based on. */
  fieldId: number;
  /** The expected value of the field. */
  value: string;
}

/** Represents a request to add a clause to a document. */
export interface AddDocumentClauseRequest {
  /** The id of the language of the document. */
  languageId: number;
  /** The id of the clause to add. */
  clauseId: number;
  /** The order of the clause in the document. */
  order?: number | undefined;
}

/** Represents a response to adding a clause to a document. */
export interface AddDocumentClauseResponse {
  /** The clause that was added to the document. */
  clausesGroup: DocumentClauseGroupDto;
}

/** Represents a request to add a field to a party type. */
export interface AddPartyTypeFieldRequest {
  /** The id of the field to add. */
  fieldId: number;
  /** Whether the field is required. */
  required: boolean;
}

/** Represents a clause. */
export interface ClauseDto {
  /** The id of the clause. */
  clauseId: number;
  templateTranslationId: number;
  /** The clause name. */
  name: string;
  /** The group id of the clause. */
  groupId?: number | undefined;
  /** Indicates whether the clause is a master clause. */
  isMaster: boolean;
}

/** Represents information about a clause. */
export interface ClauseInfoDto {
  /** Gets or sets the ID of the clause. */
  clauseId: number;
  /** Gets or sets the name of the clause. */
  name: string;
  /** Gets or sets a value indicating whether gets or sets is master flag. */
  isMaster: boolean;
}

/** Represents a reference to a clause where a field or tag is used. */
export interface ClauseReferenceDto {
  id: number;
  name: string;
  order: number;
}

/** Represents a field. */
export interface ClauseWithFragmentsDto {
  /** The id of the clause. */
  clauseId: number;
  /** The template translation id of the clause. */
  templateTranslationId: number;
  /** The name of the field. */
  name: string;
  /** The group id of the field. */
  groupId?: number | undefined;
  /** The fragments of the field. */
  fragments: TemplateFragmentDto[];
  /** Indicates whether the clause is a master clause. */
  isMaster: boolean;
}

/** Response for cloning a contract model. */
export interface CloneContractModelResponse {
  /** The id of the cloned contract model. */
  contractModelId: number;
}

/** Represents a contract model. */
export interface ContractModelDto {
  /** Gets or sets the ID of the contract model. */
  contractModelId: number;
  /** Gets or sets the status of the contract model. */
  status: ContractModelStatus;
  /** Gets or sets the group associated with the contract model. */
  group?: ContractModelGroupDto | undefined;
  /** Gets or sets the name of the contract model. */
  name: string;
  /** Gets or sets the list of versions (snapshots) of the contract model. */
  versions: ContractModelSnapshotDto[];
  /** Gets or sets the timestamps associated with the contract model. */
  timeStamps: TimeStampsDto;
  /** Gets or sets the date and time when the last snapshot was taken. */
  lastSnapshotAt?: Date | undefined;
  /** Gets or sets the language associated with the name of the contract model. */
  language?: LanguageDto | undefined;
}

/** Represents detailed information about a contract model, including its introduction text. Inherits from Instaclause.Expert.Contracts.ContractModelDto. */
export interface ContractModelDetailsDto extends ContractModelDto {
  /** Gets or sets the introduction or description of the contract model. */
  introduction?: string | undefined;
}

/** Represents a field in a contract model with its usage in clauses. */
export interface ContractModelFieldDto {
  /** Gets the id of the field. */
  fieldId: number;
  /** Gets the label of the field. */
  label: string;
  /** Gets the description of the field. */
  description: string;
  /** Gets the origin of the field. */
  fieldOrigin: FieldOrigin;
  /** Gets the field type. */
  fieldType: FieldTypeOptions;
  /** Gets the validation regex for the field. */
  validationRegex?: string | undefined;
  /** Gets the options for the field. */
  options?: FieldOptionDto[] | undefined;
  /** Gets the list of clauses where this field is used. */
  usedClauses: ClauseReferenceDto[];
}

/** Represents a group of contract models. */
export interface ContractModelGroupDto {
  /** Gets or sets the ID of the group. */
  groupId: number;
  /** Gets or sets the name of the group. */
  name: string;
}

/** Represents a group of contract models. */
export interface ContractModelGroupWithClausesDto {
  /** Gets or sets the ID of the contract model group. */
  contractModelGroupId?: number | undefined;
  /** Gets or sets the name of the contract model group. */
  name: string;
  /** Gets or sets the list of contract models in the group. */
  contractModels: ContractModelWithClausesDto[];
}

/** Represents a role of a contract model. */
export interface ContractModelRoleDto {
  /** The id of the contract model role. */
  contractModelRoleId: number;
  /** The id of the role. */
  roleId: number;
  /** The name of the role. */
  name: string;
  /** The minimum number of assignees that the role requires. */
  min: number;
  /** The maximum number of assignees that the role allows. */
  max: number;
}

/** Represents a snapshot of a contract model. */
export interface ContractModelSnapshotDto {
  /** Gets or sets the ID of the contract model used by this snapshot. */
  snapshotContractModelId: number;
  /** Gets or sets the version of the snapshot. */
  version: number;
  /** Gets or sets the description of the snapshot. */
  description?: string | undefined;
}

/** Represents the origin of a field, indicating the template context from which the field originates. */
export enum ContractModelStatus {
  Draft = 'Draft',
  Enabled = 'Enabled',
  Disabled = 'Disabled',
}

/** Represents a tag in a contract model with its usage in clauses. */
export interface ContractModelTagDto {
  /** Gets the id of the tag. */
  tagId: number;
  /** Gets the id of the contract model. */
  contractModelId: number;
  /** Gets the id of the field. */
  fieldId?: number | undefined;
  /** Gets the id of the field. */
  roleId?: number | undefined;
  /** Gets the id of the field. */
  roleModifier?: string | undefined;
  /** Gets the label of the tag. */
  label: string;
  /** Gets the list of clauses where this tag is used. */
  usedClauses: ClauseReferenceDto[];
}

/** Represents information about a contract model. */
export interface ContractModelWithClausesDto {
  /** Gets or sets the ID of the contract model. */
  contractModelId: number;
  /** Gets or sets the name of the contract model. */
  name: string;
  /** Gets or sets the list of clauses associated with the contract model. */
  clauses: ClauseInfoDto[];
}

/** Defines the types of templates that can be associated with a contract role. Each template type determines which party or party representative the template applies to. */
export enum ContractRoleTemplateType {
  Company = 'Company',
  Individual = 'Individual',
  IndividualRepresentative = 'IndividualRepresentative',
  CompanyRepresentative = 'CompanyRepresentative',
}

/** Represents the response to a request to get a list of clauses. */
export interface CreateClauseRequest {
  /** The name of the new clause. */
  name: string;
  /** The group id of the new clause. */
  groupId?: number | undefined;
  /** The language id of the new clause. */
  languageId: number;
}

/** Represents the response to a request to get a list of clauses. */
export interface CreateClauseResponse {
  /** The clause id. */
  clauseId: number;
  /** The corresponding template translation id of the clause. */
  templateTranslationId: number;
}

/** Represents a request to create a contract model. */
export interface CreateContractModelGroupRequest {
  /** The id of the language that the contract model is in. */
  languageId: number;
  /** The name of the contract model. */
  name: string;
}

/** Represents the response to a request to create a contract model. */
export interface CreateContractModelGroupResponse {
  /** The id of the contract model that was created. */
  contractModelId: number;
}

/** Represents a request to create a contract model question. */
export interface CreateContractModelQuestionRequest {
  languageId: number;
  /** The field type. */
  fieldType: FieldTypeOptions;
  /** The label of the question. */
  label: string;
  /** The description of the question. */
  description: string;
  /** The validation regex of the question. */
  validationRegex?: string | undefined;
  /** The options of the question for when the FieldType is 'select'. */
  options?: FieldOptionDto[] | undefined;
}

/** Represents a response to create contract model question. */
export interface CreateContractModelQuestionResponse {
  /** The question that was created. */
  question: QuestionDto;
}

/** Represents a request to create a contract model. */
export interface CreateContractModelRequest {
  /** The name of the contract model. */
  name: string;
  introductionText: string;
  groupId?: number | undefined;
  languageId: number;
}

/** Represents the response to a request to create a contract model. */
export interface CreateContractModelResponse {
  /** The id of the contract model that was created. */
  contractModelId: number;
}

/** Represents a request to create a document clause condition. */
export interface CreateDocumentClauseConditionRequest {
  /** The id of the field. */
  fieldId?: number | undefined;
  /** The id of the role. */
  roleId?: number | undefined;
  /** The modifier that can be used on a role. */
  roleModifier?: string | undefined;
  /** The values that must be met for the condition to be satisfied. */
  validValues: string[];
}

/** Represents a response to create document clause condition. */
export interface CreateDocumentClauseConditionResponse {
  /** The id of the created document clause condition. */
  conditionId: number;
}

/** Represents a request to create a document clause variation. */
export interface CreateDocumentClauseVariationRequest {
  /** The id of the clause that the variation is based on. If null, a new clause will be created. */
  clauseId?: number | undefined;
  /** The values of each of the group fields for this clause to be the active one in the group. */
  validValues: string[][];
  languageId: number;
}

/** Represents a response to create document clause variation. */
export interface CreateDocumentClauseVariationResponse {
  /** The document clause that was created. */
  documentClause: DocumentClauseDto;
  /** The fragments of the document clause. */
  fragments?: TemplateFragmentDto[] | undefined;
}

/** Represents a request to create a document. */
export interface CreateDocumentRequest {
  /** The language id. */
  languageId: number;
  /** The name of the document. */
  name: string;
}

/** Represents a response to create a document. */
export interface CreateDocumentResponse {
  /** The document id. */
  documentId: number;
}

/** Represents a request to create field options. */
export interface CreateFieldOptionRequest {
  languageId: number;
  /** The options to create. */
  options: FieldOptionDto[];
}

/** Represents a response to create field options. */
export interface CreateFieldOptionResponse {
  /** The List of the created field options. */
  fieldOptions: FieldOptionDto[];
}

/** Represents a request to create a field. */
export interface CreateFieldRequest {
  /** The identifier of the language. */
  languageId: number;
  /** The field type. */
  fieldType: FieldTypeOptions;
  /** The identifier of the field. */
  label: string;
  /** The description of the field. */
  description: string;
  /** The validation regex of the field. */
  validationRegex?: string | undefined;
  /** The options of the field. */
  options?: FieldOptionDto[] | undefined;
  /** The origin of the field. If it used by a question, clause, role or tag. */
  origin?: FieldOrigin;
}

/** Represents a response to create field. */
export interface CreateFieldResponse {
  /** The created field. */
  field: FieldDto;
}

/** Represents a request to create a role. */
export interface CreateRoleRequest {
  /** The language id of the role. */
  languageId: number;
  /** The name of the role. */
  name: string;
  /** The ids of the party types allowed to have this role. */
  allowedPartyTypes: PartyTypeOptions[];
  /** A scriban template to be used when a party of type individual is assigned this role. */
  individualTemplate?: FragmentSnapshotDto[] | undefined;
  /** A scriban template to be used when a party of type company is assigned this role. */
  companyTemplate?: FragmentSnapshotDto[] | undefined;
  /** A scriban template to be used for party individual representatives. */
  individualRepresentativeTemplate?: FragmentSnapshotDto[] | undefined;
  /** A scriban template to be used for party company representatives. */
  companyRepresentativeTemplate?: FragmentSnapshotDto[] | undefined;
}

/** Represents a response to create a role. */
export interface CreateRoleResponse {
  /** The id of the created role. */
  roleId: number;
  /** The name of the created role. */
  name: string;
}

/** Request to create a snapshot. */
export interface CreateSnapshotRequest {
  /** The description of the snapshot. */
  description?: string | undefined;
}

/** Response to create a snapshot. */
export interface CreateSnapshotResponse {
  /** The id of the snapshot. */
  snapshotId: number;
  /** The id of the contract model associated with the snapshot. */
  snapshotContractModelId: number;
}

/** Represents a request to create a tag branch. */
export interface CreateTagBranchRequest {
  /** The language id of the tag. */
  languageId: number;
  /** The value that the field of tag should have for this branch to be selected. */
  expected: string;
  /** The order of the branch in the tag. */
  order: number;
}

/** Represents a response to create a tag branch. */
export interface CreateTagBranchResponse {
  /** The created tag branch. */
  tagBranch: TagBranchDto;
}

/** Represents a request to create a tag. */
export interface CreateTagRequest {
  /** The id of the language that the tag was created. */
  languageId: number;
  /** The label of the tag. */
  label: string;
  /** The id of the associated field. */
  fieldId?: number | undefined;
  /** The id of the associated role. */
  roleId?: number | undefined;
  /** The modifier of the associated role. Required if role id is provided. */
  roleModifier?: string | undefined;
}

/** Represents a response to create a tag. */
export interface CreateTagResponse {
  /** The id of the created tag. */
  tagId: number;
}

/** Represents the settings associated with a customer, including templates and versioning information. */
export interface CustomerThemeDto {
  /** Gets or sets the header template associated with the customer. */
  headerTemplate?: string | undefined;
  /** Gets or sets the footer template associated with the customer. */
  footerTemplate?: string | undefined;
  cssVariables?: string | undefined;
  cssStyles?: string | undefined;
}

/** Enumeration representing various types of fields. */
export enum DefaultFieldType {
  Name = 'Name',
  Address = 'Address',
  Email = 'Email',
  Phone = 'Phone',
  NationalIdNumber = 'NationalIdNumber',
  KBO = 'KBO',
  RPR = 'RPR',
  FirstName = 'FirstName',
  MiddleName = 'MiddleName',
  LastName = 'LastName',
  Street = 'Street',
  HouseNumber = 'HouseNumber',
  PostalCode = 'PostalCode',
  Municipality = 'Municipality',
  BirthPlace = 'BirthPlace',
  BirthDate = 'BirthDate',
  TypeOfLegalEntity = 'TypeOfLegalEntity',
  Function = 'Function',
  Website = 'Website',
}

/** Represents a detailed document. */
export interface DetailedDocumentDto {
  /** The document id. */
  documentId: number;
  /** The name of the document. */
  name: string;
  /** A value indicating whether the document is a snapshot. */
  isSnapshot: boolean;
  /** The document clauses groups. */
  clausesGroups: DocumentClauseGroupWithFragmentsDto[];
}

/** Represents a detailed tag with it branches. */
export interface DetailedTagDto {
  /** The tag id. */
  tagId: number;
  /** The tag label. */
  label: string;
  /** The field of the tag. */
  field?: FieldDto | undefined;
  /** The role id associated with the tag. */
  roleId?: number | undefined;
  /** The role modifier. */
  roleModifier?: string | undefined;
  /** The branches of the tag. */
  branches: TagBranchDto[];
}

/** Represents a document clause. */
export interface DocumentClauseDto {
  /** The document clause id. */
  documentClauseId: number;
  /** The clause. */
  clause: ClauseDto;
  /** The ids of the conditions. */
  conditionsId?: number[] | undefined;
  /** The valid values of each of the group fields for this clause to be the active one in the group. */
  fieldsValidValues?: string[][] | undefined;
}

/** Represents a document clause group. */
export interface DocumentClauseGroupDto {
  /** The order of the group in the document. */
  order: number;
  /** The fields that the group is based on. */
  conditionFields?: FieldDto[] | undefined;
  /** The clauses of the group. */
  clauses: DocumentClauseDto[];
}

/** Represents a document clause group. */
export interface DocumentClauseGroupWithFragmentsDto {
  /** The order of the group in the document. */
  order: number;
  /** The ids of the questions used by this clause group. */
  fieldsIds: number[];
  /** The clauses of the group. */
  clauses: DocumentClauseWithFragmentsDto[];
}

/** Represents a Data Transfer Object (DTO) for a document clause. */
export interface DocumentClauseInfoDto {
  /** Gets or sets the unique identifier of the document. */
  documentId: number;
  /** Gets or sets the name of the document. This field is required. */
  documentName: string;
  /** Gets or sets the id of the contract model associated with the document. This field is required. */
  contractModelId: number;
  /** Gets or sets the name of the contract model associated with the document. This field is required. */
  contractModelName: string;
  /** Gets or sets the name of the contract model group associated with the clause.
This property is required. */
  contractModelGroupName: string;
}

/** Represents a document clause. */
export interface DocumentClauseWithFragmentsDto {
  /** The document clause id. */
  documentClauseId: number;
  /** The clause. */
  clause: ClauseWithFragmentsDto;
  /** The ids of the condition fields. */
  conditionIds?: number[] | undefined;
  /** The valid values of the group field for this clause to be the active one in the group. */
  validValues?: string[][] | undefined;
}

/** Represents a document. */
export interface DocumentDto {
  /** The id of the document. */
  documentId: number;
  /** The name of the document. */
  name: string;
}

export interface ExportClause {
  /** Gets the template associated with this clause. */
  template?: ExportTemplate | undefined;
  /** Gets the name of the clause. */
  nameLangString?: ExportLangString | undefined;
}

export interface ExportContractModel {
  /** Gets or sets a value indicating whether the model is disabled. */
  disabled: boolean;
  /** Gets the collection of parties associated with this contract model. */
  roles?: ExportContractModelRole[] | undefined;
  /** Gets the collection of documents associated with this contract model. */
  documents?: ExportDocument[] | undefined;
  /** Gets the collection of questions associated with this contract model. */
  questions?: ExportQuestion[] | undefined;
  /** Gets the name of the contract model. */
  nameLangString: ExportLangString;
  /** Gets the introduction text of the contract model. */
  introductionLangString?: ExportLangString | undefined;
  /** Gets the collection of translations associated with this contract model. */
  translations?: ExportContractModelTranslation[] | undefined;
  /** Gets the collection of fields associated with this contract model. */
  fields?: ExportField[] | undefined;
  /** Gets the collection of tags associated with this contract model. */
  tags?: ExportTag[] | undefined;
}

export interface ExportContractModelRole {
  /** Gets or sets the minimum number of members of this group. */
  min: number;
  /** Gets or sets the maximum number of members of this group. */
  max: number;
  role: ExportContractRole;
  /** Gets the collection of conditions that must be met for this party to be required in the contract. */
  conditions?: ExportContractModelRoleCondition[] | undefined;
}

export interface ExportContractModelRoleCondition {
  /** Gets or sets the value for the field, which may be text, a selection identifier, or other data as appropriate.
When the ContractFieldValue associated with the FieldId has this value, the condition is satisfied. */
  value: string;
  /** Gets the field used as condition evaluation for the contract model role. */
  field?: ExportField | undefined;
}

/** Represents a translation of a contract model, allowing for multiple languages to be supported. */
export interface ExportContractModelTranslation {
  /** Gets the id of the language associated with this translation. */
  langCode: string;
  /** Gets or sets the translation status of the contract model translation. */
  completion: number;
}

export interface ExportContractRole {
  roleId: number;
  /** Gets or sets the template data for a person associated with this party. */
  personTemplateData?: string | undefined;
  /** Gets or sets the template data for a company associated with this party. */
  companyTemplateData?: string | undefined;
  /** Gets or sets the allowed party type identifiers, defining the types of entities that can fulfill the role of this party. */
  allowedPartyTypeIds: PartyTypeOptions[];
  /** Gets the label used to uniquely identify the party within a contract model. */
  labelLangString: ExportLangString;
  /** Gets or sets the template associated with an individual party for this contract role. */
  templates: ExportContractRoleTemplate[];
}

export interface ExportContractRoleTemplate {
  /** Gets the type of the template associated with the role. */
  templateType: ContractRoleTemplateType;
  /** Gets the template associated with this field option. */
  template?: ExportTemplate | undefined;
}

export interface ExportDocument {
  /** Gets the collection of clauses associated with this document, representing the individual parts or sections of the document. */
  clauses?: ExportDocumentClause[] | undefined;
  /** Gets the name of the document. */
  nameLangString: ExportLangString;
}

export interface ExportDocumentClause {
  /** Gets or sets the order of this clause within the document, determining its sequence among other clauses. */
  order: number;
  /** Gets the rendering options for this clause, detailing how this clause should be rendered in the document. */
  renderingOptions?: string | undefined;
  /** Gets the clause entity associated with this document clause, detailing the content or provision this document clause represents. */
  clause?: ExportClause | undefined;
  /** Gets the conditions for this clause, detailing the conditions that must be met for this clause to be rendered in the document. */
  conditions?: ExportDocumentClauseCondition[] | undefined;
}

export interface ExportDocumentClauseCondition {
  /** Gets or sets the values that must be met for the condition to be satisfied. */
  validValues: string[] | undefined;
  /** Gets the field associated with this condition. */
  field?: ExportField | undefined;
  /** Gets the role used as condition evaluation for the condition. */
  role?: ExportContractRole | undefined;
  /** Gets the modifier that can be used on a role as condition evaluation for the condition. */
  roleModifier?: string | undefined;
}

/** Represents a field within the system, which can be a part of a party, question, or clause. */
export interface ExportField {
  fieldId: number;
  /** Gets or sets the default type of the field, used for mapping with external data from integration. */
  defaultFieldType?: DefaultFieldType | undefined;
  /** Gets or sets the order in which the field should be displayed or processed, relative to other fields. */
  fieldOrigin: FieldOrigin;
  /** Gets or sets the field type id, linking this field to its defined type which dictates how the field is rendered and interacted with. */
  fieldTypeId: FieldTypeOptions;
  /** Gets or sets the validation regex pattern for the field, used to validate input data for the field. */
  validationRegex?: string | undefined;
  /** Gets the field type of this field, detailing how the field is rendered and the kind of data it holds. */
  fieldType: FieldTypeOptions;
  /** Gets the collection of options available for this field, applicable to fields that provide a selection of values. */
  options?: ExportFieldOption[] | undefined;
  /** Gets the collection of questions that utilize this field, linking the field to its use cases within questions. */
  questions?: ExportQuestion[] | undefined;
  /** Gets the collection of clauses that incorporate this field, linking the field to its application within various clauses. */
  templateFragments?: ExportTemplateFieldFragment[] | undefined;
  /** Gets the collection of tags associated with this field, allowing for categorization and filtering of fields. */
  tags?: ExportTag[] | undefined;
  /** Gets the collection of clauses conditions that utilize this field. */
  clausesConditions?: ExportDocumentClauseCondition[] | undefined;
  /** Gets the collection of role conditions that utilize this field. */
  rolesConditions?: ExportContractModelRoleCondition[] | undefined;
  /** Gets the collection of contract model questions that utilize this field. */
  labelLangString: ExportLangString;
  /** Gets the description of the field, providing additional details about its purpose or usage. */
  descriptionLangString: ExportLangString;
}

/** Represents an option within a field, specifically for fields that allow selecting from predefined values, such as dropdowns or radio buttons. */
export interface ExportFieldOption {
  /** Gets or sets the value associated with this option, which is the actual data stored or transmitted when this option is selected. */
  value: string;
  /** Gets the template associated with this field option. */
  template?: ExportTemplate | undefined;
  /** Gets the order in which this option appears relative to other options within the same field, affecting display sequence. */
  order: number;
  /** Gets the label for the option, used for display purposes to present the option to users. */
  labelLangString: ExportLangString;
}

/** Represents a language string, which is a string that can be translated into multiple languages. */
export interface ExportLangString {
  /** Gets the id of the language string. */
  id: number;
  /** Gets the translations of the language string. */
  translations: ExportLangStringTranslation[];
}

/** Represents a translation of a language string. */
export interface ExportLangStringTranslation {
  /** Gets the id of the language that the translation is in. */
  langCode: string;
  /** Gets the translated value of the language string. */
  value: string;
  /** Gets or sets the status of the translation. */
  translationStatusId: TranslationStatusOptions;
  /** Gets the language string associated with this translation. */
  langString?: ExportLangString | undefined;
  /** Gets the status of the translation. */
  translationStatus?: TranslationStatus | undefined;
}

/** Represents a question that may be posed within the context of a contract or document. Used to gather information or make decisions that affect the document's content or clauses. Are mainly used in the conditional clauses. */
export interface ExportQuestion {
  /** Gets or sets the order of the question within the contract model. */
  order: number;
  /** Gets the field associated with this question, defining the response type and validation for the question's answer. */
  field: ExportField;
  /** Gets the title of the question, which may be presented to the user as part of the questionnaire or form. */
  titleLangString?: ExportLangString | undefined;
}

export interface ExportTag {
  tagId: number;
  roleId?: number | undefined;
  roleModifier?: string | undefined;
  /** Gets the field used as condition evaluation for the tag. */
  field?: ExportField | undefined;
  /** Gets the collection of contract model questions that utilize this field. */
  labelLangString: ExportLangString;
  /** Gets the label for the option, used for display purposes to present the option to users. */
  branches: ExportTagBranch[];
}

export interface ExportTagBranch {
  /** Gets the id of the tag that this branch belongs to. */
  tagId: number;
  /** Gets or sets the order that this branch should appear in the tag. */
  order: number;
  /** Gets or sets the expected value that the FieldId of the tag should have in the ContractFieldValue for this branch to be evaluated as true. */
  expected: string;
  /** Gets the template associated with this field option. */
  template?: ExportTemplate | undefined;
}

export interface ExportTemplate {
  /** Gets the id of the language of the template. */
  translations: ExportTemplateTranslation[];
}

/** Represents a field fragment within a template. The field fragment is used to render a field within a template. */
export interface ExportTemplateFieldFragment {
  /** Gets or sets the modifier for the field fragment.
The modifier is used to apply scriban functions. */
  modifier?: string | undefined;
  /** Gets or sets the order that this fragment should appear in the template. */
  order: number;
  /** Gets the field if that this fragment represents. */
  fieldId: number;
}

export interface ExportTemplateRoleFragment {
  /** Gets or sets the modifier for the role fragment.
The modifier is used to specify a field of the role or apply scriban functions. */
  modifier?: string | undefined;
  /** Gets or sets the order that this fragment should appear in the template. */
  order: number;
  /** Gets the role that this fragment represents. */
  role?: ExportContractRole | undefined;
}

export interface ExportTemplateTagFragment {
  /** Gets or sets the order that this fragment should appear in the template. */
  order: number;
  /** Gets the tag that this fragment represents. */
  tag?: ExportTag | undefined;
}

export interface ExportTemplateTextFragment {
  /** Gets or sets the text of the fragment. */
  text: string;
  /** Gets or sets the order that this fragment should appear in the template. */
  order: number;
}

export interface ExportTemplateTranslation {
  /** Gets the id of the language associated with this translation. */
  langCode: string;
  /** Gets or sets the translation status of the template translation. */
  translationStatusId: TranslationStatusOptions;
  /** Gets the fields fragments os the template. */
  fields: ExportTemplateFieldFragment[];
  /** Gets the roles fragments of the template. */
  roles: ExportTemplateRoleFragment[];
  /** Gets the tags fragments of the template. */
  tags?: ExportTemplateTagFragment[] | undefined;
  /** Gets the text fragments of the template. */
  texts: ExportTemplateTextFragment[];
}

/** Represents a field. */
export interface FieldDto {
  /** Gets the id of the field. */
  fieldId: number;
  /** Gets the label of the field. */
  label: string;
  /** Gets the description of the field. */
  description: string;
  /** Gets the origin of the field. */
  fieldOrigin: FieldOrigin;
  /** Gets the field type. */
  fieldType: FieldTypeOptions;
  /** Gets the validation regex for the field. */
  validationRegex?: string | undefined;
  /** Gets the options for the field. */
  options?: FieldOptionDto[] | undefined;
}

/** Represents a data transfer object for a field option. */
export interface FieldOptionDto {
  /** Gets or sets the id of the field option. */
  fieldOptionId?: number | undefined;
  /** Gets or sets the value of the field option. */
  value: string;
  /** Gets or sets the display label of the field option. */
  label: string;
  /** Gets the associated template. */
  template?: TemplateDto | undefined;
}

/** Represents the origin of a field, indicating the context in which the field is used. */
export enum FieldOrigin {
  Question = 'Question',
  Clause = 'Clause',
  Party = 'Party',
  Tag = 'Tag',
}

/** Represents the options for the type of field that can be used in contracts. */
export enum FieldTypeOptions {
  Select = 'Select',
  Text = 'Text',
  Integer = 'Integer',
  DateTime = 'DateTime',
  Email = 'Email',
  Phone = 'Phone',
  Currency = 'Currency',
  Boolean = 'Boolean',
  Date = 'Date',
  Time = 'Time',
}

/** Represents a snapshot fragment. */
export interface FragmentSnapshotDto {
  /** The type of the fragment. */
  type: FragmentType;
  /** The id of the item of the fragment. The FieldId for FieldFragments,
            the RoleId for RoleFragments and the TagId for TagFragments. */
  fragmentItemId?: number | undefined;
  /** The data of the fragment. Used only for TextFragments. */
  data?: string | undefined;
  /** The modifier of the fragment. */
  modifier?: string | undefined;
}

/** Represents a fragment type. */
export enum FragmentType {
  Field = 'Field',
  Tag = 'Tag',
  Role = 'Role',
  Text = 'Text',
}

/** Represents the response for retrieving a clause. */
export interface GetClauseResponse {
  /** The unique identifier of the clause. */
  id: number;
  /** The name of the clause. */
  name: string;
  /** A collection of associated document clause information. */
  documents: DocumentClauseInfoDto[];
}

/** Represents the response to a request to get a list of clauses. */
export interface GetClausesResponse {
  /** The list of clauses. */
  clauses: ClauseDto[];
}

/** Represents the response to a request to get a list of documents for a contract model. */
export interface GetContractModelDocumentsResponse {
  /** The list of documents. */
  documents: DocumentDto[];
}

/** Response containing the fields of a contract model. */
export interface GetContractModelFieldsResponse {
  /** The list of fields. */
  fields: ContractModelFieldDto[];
}

/** Represents a response to get contract models. */
export interface GetContractModelGroupResponse {
  /** The contract models. */
  contractModelGroup: ContractModelGroupDto;
}

/** Represents a response to get contract models. */
export interface GetContractModelGroupsResponse {
  /** The contract models. */
  contractModelGroups: ContractModelGroupDto[];
}

/** Represents a response to get contract model questions. */
export interface GetContractModelQuestionsResponse {
  /** The list of questions. */
  questions: QuestionDto[];
}

/** Represents a response to get contract models. */
export interface GetContractModelResponse {
  /** The contract models. */
  contractModel: ContractModelDetailsDto;
}

/** Represents a response to getting the roles of a contract model. */
export interface GetContractModelRolesResponse {
  /** The roles of the contract model. */
  roles: ContractModelRoleDto[];
}

/** Response containing the tags of a contract model. */
export interface GetContractModelTagsResponse {
  /** The list of tags. */
  tags: ContractModelTagDto[];
}

/** Represents a response to get contract models. */
export interface GetContractModelsResponse {
  /** The contract models. */
  contractModels: ContractModelDto[];
}

/** Represents a response containing customer templates. */
export interface GetCustomerThemeResponse {
  /** The customer theme returned in the response. */
  theme: CustomerThemeDto;
}

/** Represents a response to get document fields. */
export interface GetDocumentFieldsResponse {
  /** The fields. */
  fields: FieldDto[];
}

/** Represents a response to get a document. */
export interface GetDocumentResponse {
  /** The document. */
  document: DetailedDocumentDto;
}

/** The response for getting a field by id. */
export interface GetFieldResponse {
  /** The field details. */
  field: FieldDto;
}

/** Represents a response to get fields. */
export interface GetFieldsResponse {
  /** The fields. */
  fields: FieldDto[];
}

/** Represents the response containing grouped contract clauses. */
export interface GetGroupedClausesResponse {
  contractModelGroups: ContractModelGroupWithClausesDto[];
  unusedClauses: ClauseInfoDto[];
}

export interface GetLanguageResponse {
  language: LanguageDto;
}

export interface GetLanguagesResponse {
  languages: LanguageDto[];
}

/** Represents a response to get party type. */
export interface GetPartyTypeResponse {
  /** The party type. */
  partyType: PartyTypeDto;
}

/** Represents a response to get party types. */
export interface GetPartyTypesResponse {
  /** The party types. */
  partyTypes: PartyTypeDto[];
}

/** Represents a response to get roles. */
export interface GetRoleResponse {
  /** The role. */
  role: RoleDto;
}

/** Represents a response to get roles. */
export interface GetRolesResponse {
  /** The roles. */
  roles: RoleInfoDto[];
}

/** Response to get snapshots. */
export interface GetSnapshotsResponse {
  /** The snapshots. */
  snapshots: SnapshotDto[];
}

/** Represents a response to get tag branches. */
export interface GetTagBranchesResponse {
  /** The tag branches. */
  tagBranches: TagBranchDto[];
}

/** Represents a response to a request to get a tag. */
export interface GetTagResponse {
  /** The tag. */
  tag: DetailedTagDto;
}

/** Represents a response to get template fragments. */
export interface GetTemplateFragmentsResponse {
  /** The template fragments. */
  fragments: TemplateFragmentDto[];
}

/** Response for cloning a contract model. */
export interface ImportContractModelRequest {
  /** The structure of a contract model. */
  model: ExportContractModel;
}

export interface LanguageDto {
  languageId: number;
  name: string;
  code: string;
}

/** Represents a party type. */
export interface PartyTypeDto {
  /** The party type. */
  partyType: PartyTypeOptions;
  /** The name of the party type. */
  name: string;
  /** The template data for the party type. */
  templateData: string;
  /** The fields of the party type. */
  fields: PartyTypeFieldDto[];
}

/** Represents a field of a party type. */
export interface PartyTypeFieldDto {
  /** The party type field id. If zero indicates that this field is an additional field. */
  partyTypeFieldId: number;
  /** The field. */
  field: FieldDto;
  /** Whether the field is required. */
  isRequired: boolean;
}

/** Represents the options for the type of party that can be involved in contracts. */
export enum PartyTypeOptions {
  Company = 'Company',
  Individual = 'Individual',
}

/** Represents a question. */
export interface QuestionDto {
  /** The question id. */
  questionId: number;
  /** The corresponding field. */
  field: FieldDto;
  /** The label of the question. */
  label: string;
  /** The order of the question. */
  order: number;
}

/** Represents a role. */
export interface RoleDto {
  /** Gets or sets the id of the role. */
  roleId: number;
  /** Gets or sets the name of the role. */
  name: string;
  /** Gets or sets the allowed party types ids. */
  allowedPartyTypes: PartyTypeOptions[];
  /** Gets or sets the individual template. */
  individualTemplate?: TemplateDto | undefined;
  /** Gets or sets the company template. */
  companyTemplate?: TemplateDto | undefined;
  /** Gets or sets the individual representative template. */
  individualRepresentativeTemplate?: TemplateDto | undefined;
  /** Gets or sets the individual representative template. */
  companyRepresentativeTemplate?: TemplateDto | undefined;
  /** Gets or sets the additional fields. */
  additionalFields?: number[] | undefined;
}

export interface RoleInfoDto {
  /** Gets or sets the id of the role. */
  roleId: number;
  /** Gets or sets the name of the role. */
  name: string;
  /** Gets or sets the allowed party types ids. */
  allowedPartyTypes: PartyTypeOptions[];
}

/** Represents a snapshot of a contract model. */
export interface SnapshotDto {
  /** The id of the snapshot. */
  snapshotId: number;
  /** The id of the contract model the snapshot belongs to. */
  contractModelId: number;
  /** The description of the snapshot. */
  description?: string | undefined;
}

/** Represents a tag branch. */
export interface TagBranchDto {
  /** Gets the id of the tag branch. */
  tagBranchId: number;
  /** Gets the associated template. */
  template: TemplateDto;
  /** Gets the value for the tag branch to be selected. Use the string "_default" to mark this branch as the default one,
which is applied when none of the other branches match their expected values. */
  expected: string;
  /** Gets the order of the tag branch in the tag. */
  order: number;
}

/** Represents a template. */
export interface TemplateDto {
  /** The id of the template. */
  templateId?: number | undefined;
  /** The translations of the template. */
  translations?: TemplateTranslationDto[] | undefined;
}

/** Represents a template fragment. */
export interface TemplateFragmentDto {
  /** The type of the fragment. */
  type: FragmentType;
  fragmentId: number;
  /** The id of the item of the fragment. The FieldId for FieldFragments,
            the RoleId for RoleFragments and the TagId for TagFragments. */
  fragmentItemId: number;
  /** The order of the fragment. */
  order: number;
  /** The data of the fragment. */
  data: string;
  /** The modifier of the fragment. */
  modifier?: string | undefined;
}

/** Represents a template translation. */
export interface TemplateTranslationDto {
  /** The id of the template translation. */
  templateTranslationId: number;
  /** The id of the language. */
  languageId: number;
  /** The status of the translation. */
  status: TranslationStatusOptions;
}

export interface TimeStampsDto {
  createdAt: Date;
  createdByUser: UserDto;
  updatedAt?: Date | undefined;
  updatedByUser?: UserDto | undefined;
  deletedAt?: Date | undefined;
  deletedByUser?: UserDto | undefined;
}

/** Represents the status of a translation within the system, indicating whether a translation is pending, approved, or requires review, thus managing the workflow and quality control of translations. */
export interface TranslationStatus {
  /** Gets the id of the translation status. */
  id: TranslationStatusOptions;
  /** Gets the name of the translation status, used for display and to indicate the current state of a translation within the translation management process. */
  name: string;
}

/** Represents the status of a translation within the system, indicating whether a translation is pending, approved, or requires review, thus managing the workflow and quality control of translations. */
export enum TranslationStatusOptions {
  Missing = 'Missing',
  PendingApproval = 'PendingApproval',
  Approved = 'Approved',
  Edited = 'Edited',
}

/** Represents a request to update a clause. */
export interface UpdateClauseRequest {
  contractModelId: number;
  languageId: number;
  /** A flag indicating whether the name should be updated. */
  newName: boolean;
  /** The new name of the clause. */
  name?: string | undefined;
  /** A flag indicating whether the group id should be updated. */
  newGroupId: boolean;
  /** The new group id of the clause. */
  groupId?: number | undefined;
}

/** Represents a request to update a contract model. */
export interface UpdateContractModelGroupRequest {
  /** The id of the language that will be updated. */
  languageId: number;
  /** The new name of the contract model. */
  name: string;
}

/** Represents a request to update a contract model. */
export interface UpdateContractModelRequest {
  languageId: number;
  /** The new name of the contract model. */
  name?: string | undefined;
  introduction?: string | undefined;
  /** The status of the contract model. */
  status?: ContractModelStatus | undefined;
  /** Whether the contract model has a new group. */
  hasNewGroup: boolean;
  /** The new group id of the contract model. */
  groupId?: number | undefined;
}

/** Represents a request to update a contract model role. */
export interface UpdateContractModelRoleRequest {
  /** The new minimum number of roles. */
  min?: number | undefined;
  /** The new maximum number of roles. */
  max?: number | undefined;
}

/** Represents a request to update customer templates. */
export interface UpdateCustomerThemeRequest {
  /** The customer theme to update. */
  theme: CustomerThemeDto;
}

/** Represents a request to update a document clause condition. */
export interface UpdateDocumentClauseConditionRequest {
  /** The valid values of the condition. */
  validValues?: string[] | undefined;
}

/** Represents a request to update the order of the document clauses. */
export interface UpdateDocumentClausesOrderRequest {
  /** The position of the clause to move. */
  position: number;
  /** The new position of the clause. */
  newPosition: number;
}

/** Represents a request to update a document. */
export interface UpdateDocumentRequest {
  /** The language id of the document. */
  languageId: number;
  /** The new name of the document. */
  name?: string | undefined;
}

/** Represents a request to update a field option. */
export interface UpdateFieldOptionRequest {
  languageId: number;
  /** The new display label of the option. */
  newLabel?: string | undefined;
  /** The new value of the option. */
  newValue?: string | undefined;
}

/** Represents a request to update a field. */
export interface UpdateFieldRequest {
  /** The id of the language that is being updated. */
  languageId: number;
  /** The new field type of the field. */
  fieldType?: FieldTypeOptions | undefined;
  /** The new identifier of the field. */
  label?: string | undefined;
  /** The new description of the field. */
  description?: string | undefined;
  /** Whether the validation regex should be updated. */
  newValidationRegex: boolean;
  /** The new validation regex of the field. */
  validationRegex?: string | undefined;
}

/** Represents a request to update a contract model. */
export interface UpdatePartyTypeRequest {
  /** The id of the language that will be updated. */
  languageId: number;
  /** The new name of the contract model. */
  template: string;
}

/** Request model for updating a question's order. */
export interface UpdateQuestionRequest {
  /** The new order position for the question. */
  order: number;
}

/** Represents a request to update a role fragment. */
export interface UpdateRoleFragmentRequest {
  /** The new modifier for the role. */
  modifier?: string | undefined;
}

/** Represents a request to update a role. */
export interface UpdateRoleRequest {
  /** The language id of the role. */
  languageId: number;
  /** The name of the role. If null, the name will not be updated. */
  name: string;
  /** The ids of the party types allowed to have this role. If null, the allowed party types will not be updated. */
  allowedPartyTypes: PartyTypeOptions[];
  /** A scriban template to be used when a party of type individual is assigned this role. */
  individualTemplate?: FragmentSnapshotDto[] | undefined;
  /** A scriban template to be used when a party of type company is assigned this role. */
  companyTemplate?: FragmentSnapshotDto[] | undefined;
  /** A scriban template to be used for party individual representatives. */
  individualRepresentativeTemplate?: FragmentSnapshotDto[] | undefined;
  /** A scriban template to be used for party company representatives. */
  companyRepresentativeTemplate?: FragmentSnapshotDto[] | undefined;
}

/** Represents a response to update a role. */
export interface UpdateRoleResponse {
  /** The role. */
  role: RoleDto;
}

/** Request to update a snapshot. */
export interface UpdateSnapshotRequest {
  /** The description of the snapshot. */
  description?: string | undefined;
}

/** Represents a request to update a tag branch. */
export interface UpdateTagBranchRequest {
  /** The value that the field of tag should have for this branch to be selected. */
  expected?: string | undefined;
  /** The order of the branch in the tag. */
  order?: number | undefined;
}

/** Update tag request. */
export interface UpdateTagRequest {
  /** The id of the language that the tag was updated. */
  languageId: number;
  /** The new tag label. */
  label?: string | undefined;
  /** The new field id. */
  fieldId?: number | undefined;
  /** The new role id. */
  roleId?: number | undefined;
  /** The new role modifier. Requried if Role Id is provided. */
  roleModifier?: string | undefined;
}

/** Represents a request to fully update a template, deleting all existing fragments and replacing them with the provided ones. */
export interface UpdateTemplateRequest {
  /** Contract model identificator */
  contractModelId: number;
  /** The template fragments. */
  fragments: FragmentSnapshotDto[];
}

export interface UserDto {
  userId: number;
  customerId?: number | undefined;
  displayName: string;
  email: string;
  /** Represents the type of user in the system, such as an expert or an accountant. */
  userType: UserType;
  /** Represents the role of a user in the system, such as an administrator or a regular user. */
  userRole: UserRole;
}

/** Represents the role of a user in the system, such as an administrator or a regular user. */
export enum UserRole {
  Admin = 'Admin',
  User = 'User',
}

/** Represents the type of user in the system, such as an expert or an accountant. */
export enum UserType {
  Expert = 'Expert',
  Accountant = 'Accountant',
  BackOffice = 'BackOffice',
}

export class ApiException extends Error {
  override message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isApiException = true;

  static isApiException(obj: any): obj is ApiException {
    return obj.isApiException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): Observable<any> {
  if (result !== null && result !== undefined) {
    return throwError(() => result);
  }

  return throwError(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next('');
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = (event) => {
        observer.next((event.target as any).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}
